// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Scoped to signup wizard inside .form_block_login */

.form_block_login .signup-wizard-step-meta {
  text-align: center;
  font-size: 0.8rem;
  margin: -4px 0 8px;
  opacity: 0.65;
  letter-spacing: 0.02em;
}

/* Step indicator (1–4) */
.form_block_login .signup-wizard-steps-bar {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  margin: 0 0 18px;
  padding: 0;
  list-style: none;
}

.form_block_login .signup-wizard-steps-bar li {
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.22);
  transition: transform 0.2s ease, background 0.2s ease;
}

body.light_theme .form_block_login .signup-wizard-steps-bar li {
  background: rgba(0, 0, 0, 0.15);
}

.form_block_login .signup-wizard-steps-bar li.is-done {
  background: rgba(209, 170, 103, 0.55);
}

.form_block_login .signup-wizard-steps-bar li.is-active {
  background: #d1aa67;
  transform: scale(1.25);
}

body.light_theme .form_block_login .signup-wizard-steps-bar li.is-active {
  background: #c49a4e;
}

body.light_theme .form_block_login .signup-wizard-step-meta {
  opacity: 0.55;
}

/* Step 1 email: danger border — must beat public/style.css focus rule (border … !important) */
.login_section .form_block_login .email_code.eids-email-wrap.signup-step1-email--error .input_filed,
.login_section .form_block_login .eids-email-wrap.signup-step1-email--error .input_filed,
.login_fullhieght .login_section .form_block_login .email_code.eids-email-wrap.signup-step1-email--error .input_filed,
.login_fullhieght .login_section .form_block_login .eids-email-wrap.signup-step1-email--error .input_filed,
.form_block_login .email_code.eids-email-wrap.signup-step1-email--error .input_filed,
.form_block_login .eids-email-wrap.signup-step1-email--error .input_filed,
.login_section .form_block_login .email_code.eids-email-wrap.signup-step1-email--error .input_filed:focus,
.login_section .form_block_login .email_code.eids-email-wrap.signup-step1-email--error .input_filed:focus-visible,
.login_section .form_block_login .eids-email-wrap.signup-step1-email--error .input_filed:focus,
.login_section .form_block_login .eids-email-wrap.signup-step1-email--error .input_filed:focus-visible,
.login_fullhieght .login_section .form_block_login .email_code.eids-email-wrap.signup-step1-email--error .input_filed:focus,
.login_fullhieght .login_section .form_block_login .email_code.eids-email-wrap.signup-step1-email--error .input_filed:focus-visible,
.login_fullhieght .login_section .form_block_login .eids-email-wrap.signup-step1-email--error .input_filed:focus,
.login_fullhieght .login_section .form_block_login .eids-email-wrap.signup-step1-email--error .input_filed:focus-visible {
  border: 1px solid #dc2626 !important;
  box-shadow: 0 0 0 1px rgba(220, 38, 38, 0.25) !important;
  outline: none !important;
}

body.light_theme .login_section .form_block_login .email_code.eids-email-wrap.signup-step1-email--error .input_filed,
body.light_theme .login_section .form_block_login .eids-email-wrap.signup-step1-email--error .input_filed,
body.light_theme .login_fullhieght .login_section .form_block_login .email_code.eids-email-wrap.signup-step1-email--error .input_filed,
body.light_theme .login_fullhieght .login_section .form_block_login .eids-email-wrap.signup-step1-email--error .input_filed,
body.light_theme .login_section .form_block_login .email_code.eids-email-wrap.signup-step1-email--error .input_filed:focus,
body.light_theme .login_section .form_block_login .email_code.eids-email-wrap.signup-step1-email--error .input_filed:focus-visible,
body.light_theme .login_section .form_block_login .eids-email-wrap.signup-step1-email--error .input_filed:focus,
body.light_theme .login_section .form_block_login .eids-email-wrap.signup-step1-email--error .input_filed:focus-visible,
body.light_theme .login_fullhieght .login_section .form_block_login .email_code.eids-email-wrap.signup-step1-email--error .input_filed,
body.light_theme .login_fullhieght .login_section .form_block_login .eids-email-wrap.signup-step1-email--error .input_filed,
body.light_theme .login_fullhieght .login_section .form_block_login .email_code.eids-email-wrap.signup-step1-email--error .input_filed:focus,
body.light_theme .login_fullhieght .login_section .form_block_login .email_code.eids-email-wrap.signup-step1-email--error .input_filed:focus-visible,
body.light_theme .login_fullhieght .login_section .form_block_login .eids-email-wrap.signup-step1-email--error .input_filed:focus,
body.light_theme .login_fullhieght .login_section .form_block_login .eids-email-wrap.signup-step1-email--error .input_filed:focus-visible {
  border: 1px solid #dc2626 !important;
  box-shadow: 0 0 0 1px rgba(220, 38, 38, 0.25) !important;
  outline: none !important;
}

.login_section .form_block_login .auth-phone-field.signup-step1-phone--error,
.login_fullhieght .login_section .form_block_login .auth-phone-field.signup-step1-phone--error,
.form_block_login .auth-phone-field.signup-step1-phone--error {
  border: 1px solid #dc2626 !important;
  box-shadow: 0 0 0 1px rgba(220, 38, 38, 0.25) !important;
}

body.light_theme .login_section .form_block_login .auth-phone-field.signup-step1-phone--error,
body.light_theme .login_fullhieght .login_section .form_block_login .auth-phone-field.signup-step1-phone--error {
  border: 1px solid #dc2626 !important;
  box-shadow: 0 0 0 1px rgba(220, 38, 38, 0.25) !important;
}

.form_block_login .signup-wizard-referral-toggle {
  display: flex;
  align-items: center;
  justify-content: start;
  width: 100%;
  padding: 10px 0 0px;
  margin-bottom: 0px;
  background: none;
  border: none;
  color: inherit;
  gap: 5px;
  font-size: 14px;
  cursor: pointer;
  text-align: left;
  opacity: 1;
}

.form_block_login .signup-wizard-referral-toggle i {
  transition: transform 0.2s ease;
  font-size: 18px;
}

.form_block_login .signup-wizard-referral-toggle.is-open i {
  transform: rotate(180deg);
}

.form_block_login .signup-wizard-agree {
  display: flex;
  align-items: flex-start;
  gap: 10px;
  margin: 14px 0 4px;
  font-size: 13px;
  line-height: 1.5;
}

.form_block_login .signup-wizard-agree input[type="checkbox"] {
  width: 16px;
  height: 16px;
  margin-top: 2px;
  flex-shrink: 0;
  cursor: pointer;
  accent-color: #CBA763;
}

.form_block_login .signup-wizard-agree label {
  margin: 0;
  cursor: pointer;
  color: #A0A3A7;
}

.form_block_login .signup-wizard-agree a {
  color: #CBA763;
  /* text-decoration: underline; */
}

.form_block_login .signup-wizard-agree__link {
  padding: 0;
  border: 0;
  background: none;
  font: inherit;
  color: #CBA763;
  cursor: pointer;
}

.form_block_login .signup-wizard-agree__link:hover {
  text-decoration: underline;
}

.form_block_login .signup-wizard-agree--error label {
  color: #f6465d;
}

.form_block_login .signup-wizard-agree--error input[type="checkbox"] {
  outline: 1px solid #f6465d;
  outline-offset: 2px;
  border-radius: 3px;
}

body.light_theme .form_block_login .signup-wizard-agree label {
  color: #4A5565;
}

body.light_theme .form_block_login .signup-wizard-agree--error label {
  color: #f6465d;
}

.form_block_login .signup-wizard-divider {
  display: flex;
  align-items: center;
  gap: 12px;
  color: #a6a6a6;
  margin: 5px 0px 20px;
  font-size: 0.85rem;
  opacity: 0.8;
}

body.light_theme .form_block_login .signup-wizard-divider {
  color: #525252;
}

.form_block_login .signup-wizard-divider::before,
.form_block_login .signup-wizard-divider::after {
  content: "";
  flex: 1 1;
  height: 1px;
  background: rgba(255, 255, 255, 0.25);
}

body.light_theme .form_block_login .signup-wizard-divider::before,
body.light_theme .form_block_login .signup-wizard-divider::after {
  background: #e5e5e5;
}

.form_block_login .signup-wizard-social-row {
  display: flex;
  justify-content: center;
  gap: 52px;
  margin-bottom: 8px;
}

.form_block_login .signup-wizard-social-btn {
  width: 48px;
  height: 48px;
  border-radius: 12px;
  border: 1px solid #f2f3f40f;
  background: rgba(255, 255, 255, 0.06);
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  padding: 0;
}

body.light_theme .form_block_login .signup-wizard-social-btn {
  border: 1px solid #F2F3F4;
}

.form_block_login .signup-wizard-social-btn img {
  width: 24px;
  height: 24px;
  object-fit: contain;
}

.form_block_login .signup-wizard-social-btn:disabled {
  opacity: 0.8;
  cursor: not-allowed;
}

.form_block_login .signup-social-btn__spinner {
  width: 22px;
  height: 22px;
  border: 2px solid rgba(209, 170, 103, 0.35);
  border-top-color: #d1aa67;
  border-radius: 50%;
  flex-shrink: 0;
  animation: signup-wizard-next-spin 0.65s linear infinite;
}

body.light_theme .form_block_login .signup-wizard-social-btn {
  border-color: rgb(0 0 0 / 4%);
}

.form_block_login .signup-wizard-otp-stack {
  width: 100%;
}

.form_block_login .signup-wizard-otp-row {
  display: flex;
  gap: 10px;
  justify-content: space-between;
  align-items: stretch;
  margin-bottom: 10px;
  flex-wrap: nowrap;
}

.form_block_login .signup-wizard-otp-cell {
  flex: 1 1;
  min-width: 0;
  width: 100%;
  max-width: 50px;
  height: 58px;
  text-align: center;
  font-size: 1.15rem;
  font-weight: 700;
  border-radius: 10px;
  border: 1px solid transparent;
  background: #323232 !important;
  color: inherit;
  transition: border-color 0.15s ease, background 0.15s ease;
}

body.light_theme .form_block_login .signup-wizard-otp-cell {
  background: #F5F6F7 !important;
}

.form_block_login .signup-wizard-otp-cell:focus {
  outline: none;
  border: 1px solid #1a1a1a !important;
}

body.light_theme .form_block_login .signup-wizard-otp-cell {
  background: #f2f3f4;
}

body.light_theme .form_block_login .signup-wizard-otp-cell:focus {
  border: 1px solid #1a1a1a !important;
}

.form_block_login .signup-wizard-otp-actions {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 16px;
  width: 100%;
}

.form_block_login .signup-wizard-otp-link {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 4px;
  background: none;
  border: none;
  text-decoration: underline;
  cursor: pointer;
  font-size: 15px;
  font-weight: 500;
  color: #e4e4e4;
  /* opacity: 0.9; */
  padding: 0;
}

body.light_theme .form_block_login .signup-wizard-otp-link {
  color: #070808;
}

.form_block_login .signup-otp-link__spinner {
  width: 14px;
  height: 14px;
  border: 2px solid rgba(7, 8, 8, 0.2);
  border-top-color: #070808;
  border-radius: 50%;
  flex-shrink: 0;
  animation: signup-wizard-next-spin 0.65s linear infinite;
}

.form_block_login .signup-wizard-otp-link:disabled {
  opacity: 0.4;
  cursor: not-allowed;
  text-decoration: none;
}

.form_block_login .signup-wizard-otp-paste {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  text-decoration: none;
}

.form_block_login .signup-wizard-otp-paste i {
  font-size: 1rem;
  text-decoration: none;
}

/* OTP error: must override .signup-wizard-otp-cell:focus (border #1a1a1a !important) */
.form_block_login .signup-wizard-otp-stack--error .signup-wizard-otp-cell,
.form_block_login .signup-wizard-otp-stack--error .signup-wizard-otp-cell:focus,
.form_block_login .signup-wizard-otp-stack--error .signup-wizard-otp-cell:focus-visible,
body.light_theme .form_block_login .signup-wizard-otp-stack--error .signup-wizard-otp-cell,
body.light_theme .form_block_login .signup-wizard-otp-stack--error .signup-wizard-otp-cell:focus,
body.light_theme .form_block_login .signup-wizard-otp-stack--error .signup-wizard-otp-cell:focus-visible {
  border: 1px solid #dc2626 !important;
  box-shadow: 0 0 0 1px rgba(220, 38, 38, 0.25) !important;
  outline: none !important;
}

.form_block_login .signup-wizard-rule-list {
  transition: opacity 0.2s ease;
}

.form_block_login .signup-wizard-rule-list--empty {
  opacity: 0.90;
}

.form_block_login .signup-wizard-rule-list:not(.signup-wizard-rule-list--empty) {
  opacity: 1;
}

.form_block_login .signup-wizard-rule-row {
  display: flex;
  align-items: flex-start;
  gap: 5px;
  font-size: 12px;
  margin-bottom: 0px;
  opacity: 0.9;
}

.form_block_login .signup-wizard-rule-list:not(.signup-wizard-rule-list--empty) .signup-wizard-rule-row {
  opacity: 1;
}

/* Legacy class names; new rows use --ok / --bad / --pending / --idle */
.form_block_login .signup-wizard-rule-row.is-ok i,
.form_block_login .signup-wizard-rule-row--ok i {
  color: #f3f3f3;
}

body.light_theme .form_block_login .signup-wizard-rule-row.is-ok i,
body.light_theme .form_block_login .signup-wizard-rule-row--ok i {
  color: #161616;
}

.form_block_login .signup-wizard-rule-row.is-bad i,
.form_block_login .signup-wizard-rule-row--bad i {
  color: #b91c1c;
}

/* Rules after the first failure: not yet required until earlier steps pass */
.form_block_login .signup-wizard-rule-row--pending {
  opacity: 0.55;
}

.form_block_login .signup-wizard-rule-row--pending i {
  color: #e1e1e1;
}

body.light_theme .form_block_login .signup-wizard-rule-row--pending i {
  color: #8f9299;
}

.form_block_login .signup-wizard-rule-row--pending span {
  color: #eeeeee;
}

body.light_theme .form_block_login .signup-wizard-rule-row--pending span {
  color: #6b7280;
}

/* Empty password: all rules neutral */
.form_block_login .signup-wizard-rule-list--empty .signup-wizard-rule-row--idle {
  opacity: 1;
}

body.light_theme .form_block_login .signup-wizard-rule-list--empty .signup-wizard-rule-row--idle {
  opacity: 0.85;
}


.form_block_login .signup-wizard-rule-row--idle i {
  color: #9ca3af;
}

.form_block_login .signup-wizard-priv-table {
  width: 650px;
  max-width: 100%;
  margin: 0px auto;
  margin-bottom: 20px;
  border-collapse: collapse;
  font-size: 14px;
}

body.signupbg.signup-wizard-full-steps .login_form_right.signup-wizard-welcome-wide .col-sm-12.login_btn {
  width: 670px;
  max-width: 100%;
  margin: 0 auto;
}

.form_block_login .signup-wizard-priv-table th,
.form_block_login .signup-wizard-priv-table td {
  padding: 10px 8px;
  border-bottom: none;
  text-align: center;
  color: #a5a5a5;
  font-weight: 600;
  font-size: 20px;
}

.form_block_login .signup-wizard-priv-table td img {
  filter: invert(1);
}

body.light_theme .form_block_login .signup-wizard-priv-table td img {
  filter: invert(0);
}

body.light_theme .form_block_login .signup-wizard-priv-table th,
body.light_theme .form_block_login .signup-wizard-priv-table td {
  color: #303236;
}


.form_block_login .signup-wizard-priv-table td strong {
  font-weight: 600;
}

body.light_theme .form_block_login .signup-wizard-priv-table th,
body.light_theme .form_block_login .signup-wizard-priv-table td {
  border-bottom-color: rgba(0, 0, 0, 0.08);
}

body.light_theme .form_block_login .signup-wizard-priv-table td i.ri-check-line {
  color: #000;
}

.form_block_login .signup-wizard-priv-table th:first-child,
.form_block_login .signup-wizard-priv-table td:first-child {
  text-align: left;
}

.form_block_login .signup-wizard-priv-table th {
  font-weight: 400;
  color: #84878A;
  font-size: 24px;
}

h3.mb-2.verify_hd {
  font-size: 29px;
  line-height: 140%;
  font-weight: 600;
  margin-top: -110px;
}

h3.mb-2.verify_hd span {
  color: #D1AA67;
}

.form_block_login .signup-wizard-welcome-img {
  text-align: center;
  margin: 12px 0px;
}

.form_block_login .signup-wizard-welcome-img img {
  max-width: 220px;
  height: auto;
}

.form_block_login .signup-wizard-secure {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  color: #9FA2A5;
  font-size: 14px;
  margin-top: 1px;
  opacity: 1;
}

.form_block_login .signup-wizard-subtitle {
  font-size: 0.9rem;
  margin: 0 0 16px;
  opacity: 0.75;
  line-height: 1.45;
}

/* Match .login_btn primary actions for button.next_btn and submit */
.form_block_login .login_btn button.next_btn {
  padding: 17px;
  border-radius: 50px;
  right: 0px;
  cursor: pointer;
  height: auto;
  position: relative;
  pointer-events: auto;
  color: #ffffff;
  border: none;
  width: 100%;
  background: #303236 !important;
  font-weight: 500;
  font-size: 16px;
}

.form_block_login .login_btn button.next_btn:hover:not(:disabled) {
  opacity: 0.9;
}

.form_block_login .login_btn button.next_btn:disabled {
  opacity: 0.45;
  cursor: not-allowed;
}

/* Step 1: Next button inline loader during email/referral API check */
.form_block_login .login_btn button.next_btn.signup-next-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
}

.form_block_login .signup-next-btn__spinner {
  width: 16px;
  height: 16px;
  border: 2px solid rgba(255, 255, 255, 0.4);
  border-top-color: #fff;
  border-radius: 50%;
  flex-shrink: 0;
  animation: signup-wizard-next-spin 0.65s linear infinite;
}

@keyframes signup-wizard-next-spin {
  to {
    transform: rotate(360deg);
  }
}

.form_block_login .login_btn input[type="submit"],
.form_block_login .login_btn input[type="button"],
.form_block_login .login_btn button.signup-wizard-confirm-password {
  padding: 12px;
  border-radius: 50px;
  cursor: pointer;
  color: #ffffff;
  border: none;
  width: 100%;
  background: #1a1d21 !important;
  font-weight: 500;
  font-size: 16px;
}

.form_block_login .login_btn input[type="submit"]:hover:not(:disabled),
.form_block_login .login_btn input[type="button"]:hover:not(:disabled),
.form_block_login .login_btn button.signup-wizard-confirm-password:hover:not(:disabled) {
  opacity: 0.9;
}

.form_block_login .login_btn input[type="submit"]:disabled,
.form_block_login .login_btn input[type="button"]:disabled,
.form_block_login .login_btn button.signup-wizard-confirm-password:disabled {
  opacity: 0.45;
  cursor: not-allowed;
}

/* Password step — Confirm: faded until user types (match light reference UI) */
.form_block_login .login_btn input[type="button"].signup-wizard-confirm-password,
.form_block_login .login_btn button.signup-wizard-confirm-password {
  transition: opacity 0.2s ease, background-color 0.2s ease, color 0.2s ease;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  box-sizing: border-box;
}

.form_block_login .login_btn input[type="button"].signup-wizard-confirm-password:disabled,
.form_block_login .login_btn button.signup-wizard-confirm-password:disabled {
  opacity: 1 !important;
  background: #343434 !important;
  color: #e9e9e9 !important;
  cursor: not-allowed;
}

.form_block_login .login_btn input[type="button"].signup-wizard-confirm-password:not(:disabled),
.form_block_login .login_btn button.signup-wizard-confirm-password:not(:disabled) {
  opacity: 1 !important;
  cursor: pointer;
}

.form_block_login .login_btn input[type="button"].signup-wizard-confirm-password:not(:disabled):hover,
.form_block_login .login_btn button.signup-wizard-confirm-password:not(:disabled):hover {
  opacity: 0.92 !important;
}

/* Gold Confirm — inline spinner (dark on light/gold) */
.form_block_login .signup-confirm-btn__spinner {
  width: 16px;
  height: 16px;
  border: 2px solid rgba(0, 0, 0, 0.12);
  border-top-color: #1a1a1a;
  border-radius: 50%;
  flex-shrink: 0;
  animation: signup-wizard-next-spin 0.65s linear infinite;
}

.form_block_login .login_btn button.signup-wizard-confirm-password:not(:disabled) .signup-confirm-btn__spinner {
  border-color: rgba(0, 0, 0, 0.18);
  border-top-color: #1a1a1a;
}

/* While API runs — stay readable (not the same as “invalid password” dim state) */
.form_block_login .login_btn button.signup-wizard-confirm-password.signup-wizard-confirm-password--busy:disabled {
  opacity: 0.95 !important;
  background: #1a1d21 !important;
  color: #000 !important;
  cursor: wait;
}

/* Password step — input: same faded "empty" look as Confirm; eye only when value present */
.form_block_login .signup-wizard-password-field .input_filed {
  transition: opacity 0.2s ease, background-color 0.2s ease, color 0.2s ease;
  border-radius: 12px;
}

.form_block_login .signup-wizard-password-field--empty .input_filed {
  opacity: 0.55 !important;
  background: rgba(255, 255, 255, 0.07) !important;
  color: rgba(200, 200, 200, 0.8) !important;
}

.form_block_login .signup-wizard-password-field--empty .input_filed::placeholder {
  color: rgba(200, 200, 200, 0.65) !important;
  -webkit-text-fill-color: rgba(200, 200, 200, 0.65) !important;
  opacity: 1;
}

/* Light theme overrides for empty password field */
body.light_theme .form_block_login .signup-wizard-password-field--empty .input_filed {
  opacity: 0.80 !important;
  background: #e4e5e7 !important;
  color: #666666 !important;
}

body.light_theme .form_block_login .signup-wizard-password-field--empty .input_filed::placeholder {
  color: #a8adb4 !important;
  -webkit-text-fill-color: #a8adb4 !important;
  opacity: 1;
}

.form_block_login .signup-wizard-password-field:not(.signup-wizard-password-field--empty) .input_filed {
  opacity: 1 !important;
  background-color: rgba(255, 255, 255, 0.06) !important;
  color: #e0e0e0;
}

.form_block_login .signup-wizard-password-field:not(.signup-wizard-password-field--empty) .input_filed::placeholder {
  color: rgba(200, 200, 200, 0.65);
  -webkit-text-fill-color: rgba(200, 200, 200, 0.65);
}

body.light_theme .form_block_login .signup-wizard-password-field:not(.signup-wizard-password-field--empty) .input_filed {
  background-color: #f5f6f7 !important;
  color: #1a1d21 !important;
}

body.light_theme .form_block_login .signup-wizard-password-field:not(.signup-wizard-password-field--empty) .input_filed::placeholder {
  color: #84888c;
  -webkit-text-fill-color: #84888c;
}

.form_block_login .signup-wizard-back {
  display: block;
  width: 100%;
  margin-top: 12px;
  padding: 0px;
  background: none;
  border: none;
  cursor: pointer;
  text-decoration: underline;
  font-size: 14px;
  color: #070808;
  font-weight: 500;
  opacity: 1;
}


/* -------------------------------------------------------------------------- */
/* Unified phone row + referral pill (signup + login)                         */
/* -------------------------------------------------------------------------- */

.form_block_login .auth-phone-field {
  display: flex;
  align-items: stretch;
  width: 100%;
  min-height: 53px;
  border-radius: 12px;
  background-color: rgba(255, 255, 255, 0.05);
  box-sizing: border-box;
  /* Reserve 2px so focus ring does not shift layout */
  border: 1px solid rgba(245, 246, 247, 0.25);
}

body.light_theme .form_block_login .auth-phone-field {
  background-color: #f5f6f7;
  border: 1px solid transparent;
}

/* Full-row focus: country + divider + number (login + signup) */
.form_block_login .auth-phone-field.auth-phone-field--unified:focus-within {
  border-color: rgba(255, 255, 255, 0.35);
  box-shadow: none;
  outline: none;
}

body.light_theme .form_block_login .auth-phone-field.auth-phone-field--unified:focus-within {
  border-color: #343539;
}

.form_block_login .auth-phone-field__country {
  flex: 0 0 auto;
  min-width: 0;
  max-width: 46%;
  display: flex;
  align-items: center;
}

@media screen and (max-width: 400px) {
  .form_block_login .auth-phone-field__country {
    max-width: 52%;
  }
}

.form_block_login .auth-phone-field__divider {
  align-self: stretch;
  width: 1px;
  min-width: 1px;
  background: rgba(150, 155, 160, 0.35);
  margin: 10px 0;
  flex-shrink: 0;
}

body.light_theme .form_block_login .auth-phone-field__divider {
  background: #dfe2e6;
}

.form_block_login .auth-phone-field__number {
  flex: 1 1 auto;
  min-width: 0;
  display: flex;
  align-items: stretch;
}

.form_block_login .auth-phone-field__input.input_filed {
  flex: 1 1;
  width: 100%;
  min-width: 0;
  height: auto;
  min-height: 53px;
  margin: 0;
  border: none;
  border-radius: 0;
  background: transparent;
  box-shadow: none;
  padding-left: 10px;
  padding-right: 14px;
  color: #e0e0e0;
}

.form_block_login .auth-phone-field__input.input_filed::placeholder {
  color: rgba(200, 200, 200, 0.65) !important;
  -webkit-text-fill-color: rgba(200, 200, 200, 0.65) !important;
  opacity: 1;
}

body.light_theme .form_block_login .auth-phone-field__input.input_filed {
  color: #1a1d21;
}

body.light_theme .form_block_login .auth-phone-field__input.input_filed::placeholder {
  color: #84888c !important;
  -webkit-text-fill-color: #84888c !important;
  opacity: 1;
}

.form_block_login .auth-phone-field__input.input_filed:focus {
  outline: none;
}

.form_block_login .auth-phone-country-inner {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  white-space: nowrap;
}

.form_block_login .auth-phone-country-flag {
  font-size: 1.1rem;
  line-height: 1;
}

.form_block_login .auth-phone-country-code {
  font-weight: 500;
  font-size: 14px;
  letter-spacing: -0.01em;
}

.form_block_login .auth-referral-field {
  margin-top: 8px;
}

h5#exampleModalLabel {
  font-size: 24px;
  font-weight: 600;
}

#VerificationOptionsModal .modal-header p {
  font-size: 16px;
  color: #515254;
}

#VerificationOptionsModal .modal.fade .modal-dialog {
  min-width: 700px;
}

form.profile_form strong {
  font-size: 20px;
  font-weight: 500;
}

form.profile_form i {
  font-size: 20px !important;
}

form.profile_form .small {
  font-size: 16px;
}

.form_block_login .auth-referral-field .input_filed {
  width: 100%;
  border-radius: 12px;
  background-color: rgba(255, 255, 255, 0.05);
  border: 1px solid rgba(245, 246, 247, 0.25);
  height: 53px;
  color: #e0e0e0;
}

.form_block_login .auth-referral-field .input_filed::placeholder {
  color: rgba(200, 200, 200, 0.65) !important;
  -webkit-text-fill-color: rgba(200, 200, 200, 0.65) !important;
  opacity: 1;
}

body.light_theme .form_block_login .auth-referral-field .input_filed {
  background-color: #f5f6f7;
  border: none;
  color: #1a1d21;
}

body.light_theme .form_block_login .auth-referral-field .input_filed::placeholder {
  color: #84888c !important;
  -webkit-text-fill-color: #84888c !important;
  opacity: 1;
}

.form_block_login .auth-referral-field.auth-referral-field--error .input_filed,
.form_block_login .auth-referral-field.auth-referral-field--error .input_filed:focus,
.form_block_login .auth-referral-field.auth-referral-field--error .input_filed:focus-visible {
  border: 1px solid #dc2626 !important;
  box-shadow: 0 0 0 1px rgba(220, 38, 38, 0.25) !important;
  outline: none !important;
}

.form_block_login .signup-wizard-referral-optional {
  font-weight: 500;
  opacity: 0.55;
}

/* React Select: country menu is portaled to body — enforce readable width (not control width) */
body .auth-phone-country__menu {
  min-width: min(calc(100vw - 24px), 360px) !important;
  width: min(calc(100vw - 24px), 360px) !important;
  max-width: min(calc(100vw - 24px), 360px) !important;
  box-sizing: border-box !important;
}

body .auth-phone-country__menu-list {
  width: 100% !important;
  box-sizing: border-box !important;
}

/* Login + Signup routes: bump weights to match deposit/withdraw ladder (global form rules live in style.css) */
body.loginbg .form_block_login h2,
body.signupbg .form_block_login h2 {
  font-weight: 600;
  font-size: 32px;
}

body .passkey-modal--loginPasskey .passkey-modal__subtitle {
  font-size: 16px;

  font-weight: 400;
}

body.loginbg .form_block_login label,
body.signupbg .form_block_login label {
  font-weight: 500;
}

body.loginbg .login_section .nav.nav-tabs li button,
body.signupbg .login_section .nav.nav-tabs li button {
  font-weight: 500;
}

/* Phone country react-select (menu portaled to body) */
body .auth-phone-country__single-value {
  font-weight: 500;
  color: #e0e0e0;
}

body.light_theme .auth-phone-country__single-value {
  color: #1a1d21;
}

body .auth-phone-country__control {
  background-color: transparent !important;
  border: none !important;
  box-shadow: none !important;
}

body .auth-phone-country__menu {
  background-color: #1e2026 !important;
  border: 1px solid rgba(255, 255, 255, 0.12) !important;
}

body.light_theme .auth-phone-country__menu {
  background-color: #ffffff !important;
  border: 1px solid #e5e7eb !important;
}

body .auth-phone-country__option {
  font-weight: 500;
  color: #e0e0e0;
  background-color: transparent;
}

body .auth-phone-country__option:hover,
body .auth-phone-country__option--is-focused {
  background-color: rgba(255, 255, 255, 0.08) !important;
}

body.light_theme .auth-phone-country__option {
  color: #1a1d21;
}

body.light_theme .auth-phone-country__option:hover,
body.light_theme .auth-phone-country__option--is-focused {
  background-color: #f3f4f6 !important;
}

body .auth-phone-country__option--is-selected {
  font-weight: 600;
  background-color: rgba(209, 170, 103, 0.2) !important;
  color: #D1AA67;
}

body.light_theme .auth-phone-country__option--is-selected {
  background-color: rgba(209, 170, 103, 0.15) !important;
  color: #a07830;
}


/* -------------------------------------------------------------------------- */
/* Signup split layout: fill viewport (no strip below black / white columns) */
/* Root cause: .sign_in_form_s used align-items: center so columns did not      */
/* stretch to full viewport height.                                            */
/* -------------------------------------------------------------------------- */

body.signupbg {
  min-height: 100vh;
  min-height: 100dvh;
  margin: 0;
  /* Fallback behind columns if anything is 1px short */
  background: linear-gradient(90deg, #000000 0%, #000000 50%, #000000 50%, #000000 100%);
}

body.signupbg #root {
  min-height: 100vh;
  min-height: 100dvh;
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
}

body.signupbg .login_fullhieght {
  flex: 1 1 auto;
  width: 100%;
  /* Match visible area below fixed header (see style.css #root:has(header.sticky-top) padding-top: 58px) */
  min-height: calc(100vh - 58px);
  min-height: calc(100dvh - 58px);
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
  padding: 0px;
  margin: 0;
}

body.signupbg .sign_in_form_s {
  /* Left promo fixed 800px; form column takes remaining width (overrides style.css repeat(2, 1fr)) */
  display: grid;
  grid-template-columns: 40% minmax(0, 1fr);
  flex: 1 1 auto;
  width: 100%;
  min-height: 0;
  min-height: 100%;
  align-items: stretch;
  align-content: stretch;
  box-sizing: border-box;
}

body.signupbg .sign_rewards {
  display: flex;
  flex-direction: column;
  padding: 90px 0px;
  justify-content: center;
  border-right: 1px solid #ffffff11;
  align-items: center;
  min-height: 100%;
  min-height: calc(100vh - 58px);
  min-height: calc(100dvh - 58px);
  width: 100%;
  max-width: 100%;
  min-width: 0;
  box-sizing: border-box;
  background-color: #000000;
}

body.signupbg .login_section.bgsignup {
  flex: 1 1 auto;
  display: flex;
  align-items: center;
  min-height: 100%;
  min-height: calc(100vh - 58px);
  min-height: calc(100dvh - 58px);
  width: 100%;
  min-width: 0;
  max-width: none;
  margin: 0;
  box-sizing: border-box;
  background-color: #000000;
}

body.light_theme.signupbg .login_section.bgsignup {
  background-color: #ffffff;
}

/* Tablet / mobile: left promo hidden in global CSS — single column, full white */
@media screen and (max-width: 991px) {
  body.signupbg {
    background: #ffffff;
  }

  body.signupbg .sign_in_form_s {
    grid-template-columns: 1fr;
    min-height: calc(100vh - 58px);
    min-height: calc(100dvh - 58px);
  }

  body.signupbg .login_section.bgsignup {
    min-height: calc(100vh - 58px);
    min-height: calc(100dvh - 58px);
    max-width: 100%;
  }
}

/* Short viewports (mobile browser chrome) */
@media screen and (max-width: 575px) {

  body.signupbg .login_fullhieght,
  body.signupbg .sign_in_form_s,
  body.signupbg .login_section.bgsignup,
  body.signupbg .sign_rewards {
    min-height: calc(100svh - 58px);
  }
}

/* -------------------------------------------------------------------------- */
/* Steps 2–4: hide left promo; single column; centered form (Create Account)   */
/* -------------------------------------------------------------------------- */

body.signupbg.signup-wizard-full-steps {
  background: #ffffff;
}

body.signupbg.signup-wizard-full-steps .sign_in_form_s {
  grid-template-columns: 1fr !important;
  max-width: 100%;
}

body.signupbg.signup-wizard-full-steps .sign_rewards {
  display: none !important;
}

body.signupbg.signup-wizard-full-steps .login_section.bgsignup {
  max-width: 100%;
  width: 100%;
  flex: 1 1 auto;
  padding: 24px 0px;
  justify-content: center;
  align-items: center;
  background-color: #000000;
}

body.light_theme.signupbg.signup-wizard-full-steps .login_section.bgsignup {
  background-color: #ffffff;
}

body.signupbg.signup-wizard-full-steps .login_form_right {
  width: 100%;
  max-width: 580px;
  margin-left: auto;
  margin-right: auto;
  padding-left: 24px;
  padding-right: 24px;
  box-sizing: border-box;
}

/* Step 4 (welcome / verify bonus): wider content; steps 2–3 stay at 520px above */
body.signupbg.signup-wizard-full-steps .login_form_right.signup-wizard-welcome-wide {
  max-width: 920px;
}

body.signupbg.signup-wizard-full-steps .form_block_login {
  margin-left: auto;
  margin-right: auto;
  width: 100%;
}

@media screen and (max-width: 1200px) {

  body.signupbg .sign_rewards {
    display: none;
  }

  body.signupbg .sign_in_form_s {
    display: flex;
    padding: 0px;
    width: 100%;
  }

  body.signupbg .login_fullhieght {
    padding: 90px 0px;
  }

}


@media screen and (max-width: 991px) {

  body.signupbg .login_fullhieght {
    padding: 50px 0px;
  }


  body.signupbg.signup-wizard-full-steps {
    background: #ffffff;
  }

  body.signupbg.signup-wizard-full-steps .login_form_right {
    padding-left: 16px;
    padding-right: 16px;
  }
}

@media screen and (max-width: 767px) {
  h3.mb-2.verify_hd {
    font-size: 1.35rem;
    margin-top: -24px;
    line-height: 1.25;
  }

  body.signupbg .sign_in_form_s {
    padding: 40px 20px;
  }

  body.signupbg .sign_rewards {
    display: none;
  }

  .form_block_login .login_btn button.next_btn {
    padding: 15px 14px;
    font-size: 16px;
  }

  body.signupbg .login_section.bgsignup .form_block_login h2 {
    font-size: 28px;
    line-height: 1.2;
  }

  body.signupbg.signup-wizard-full-steps .login_form_right,
  body.signupbg.signup-wizard-full-steps .login_form_right.signup-wizard-welcome-wide {
    padding-left: 14px;
    padding-right: 14px;
  }

  .form_block_login .signup-wizard-otp-row {
    gap: 6px;
  }

  .form_block_login .signup-wizard-welcome-img {
    margin: 0px 0px;
  }

  .form_block_login .signup-wizard-otp-cell {
    height: 50px;
    font-size: 1.05rem;
  }

  .form_block_login .signup-wizard-priv-table th,
  .form_block_login .signup-wizard-priv-table td {
    font-size: 0.8125rem;
    padding: 8px 5px;
  }

  .form_block_login .signup-wizard-priv-table th {
    font-size: 0.9rem;
  }


  body.signupbg .login_section.bgsignup .nav.nav-tabs.login-pills .nav-link {
    font-size: 14px;
    padding: 8px 12px;
    white-space: nowrap;
    flex-shrink: 0;
  }

  #VerificationOptionsModal .modal-header p {
    font-size: 14px;
  }

  form.profile_form strong {
    font-size: 16px;
  }

  form.profile_form .small {
    font-size: 14px;
  }

  .modal-content {
    padding-bottom: 24px;
  }


  h5#exampleModalLabel {
    width: 90%;
    font-size: 20px;
  }

  body.signupbg .login_fullhieght {
    padding: 20px 0px 0px !important;
  }

  body.light_theme.signupbg .sign_in_form_s {
    background-color: #fff !important;
  }

  body.signupbg .sign_in_form_s {
    background-color: #000 !important;
  }

}

/* Narrow phones */
@media screen and (max-width: 575px) {

  .form_block_login .signup-wizard-social-row {
    gap: 10px;
  }

  body.signupbg .login_section.bgsignup .nav.nav-tabs.login-pills {
    display: flex;
    flex-wrap: nowrap;
    gap: 4px;
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
    scrollbar-width: thin;
    padding-bottom: 2px;
  }

  body.signupbg .sign_in_form_s {
    padding: 10px 0px;
    background-color: #000;
  }

  .signupbg .login_section.bgsignup {
    padding: 0px 20px;
  }

  body.signupbg .login_section.bgsignup .form_block_login h2 {
    font-size: 24px;
  }

  .form_block_login.login-wizard-root .login-wizard-next-btn {
    padding: 12px 16px;
    font-size: 15px;
  }

  .form_block_login .login_btn button.next_btn {
    padding: 10px 14px;
    font-size: 13px;
  }

  body.signupbg .form_block_login .row {
    gap: 12px;
  }

  body.signupbg.signup-wizard-full-steps .login_form_right,
  body.signupbg.signup-wizard-full-steps .login_form_right.signup-wizard-welcome-wide {
    padding-left: 12px;
    padding-right: 12px;
  }

  .form_block_login .signup-wizard-subtitle {
    font-size: 0.8125rem;
    margin-bottom: 12px;
  }

  .form_block_login .signup-wizard-otp-row {
    gap: 4px;
  }

  .form_block_login .signup-wizard-otp-cell {
    height: 46px;
    font-size: 0.95rem;
    border-radius: 8px;
  }

  .form_block_login .signup-wizard-otp-link {
    font-size: 0.8125rem;
  }

  .form_block_login .signup-wizard-rule-row {
    font-size: 11px;
    gap: 4px;
  }

  .form_block_login .signup-wizard-social-btn {
    width: 44px;
    height: 44px;
  }

  h3.mb-2.verify_hd {
    font-size: 1.1rem;
    margin-top: -50px;
    margin-bottom: 8px;
  }

  .form_block_login .signup-wizard-welcome-img img {
    max-width: 150px;
  }

  .form_block_login .signup-wizard-priv-table {
    width: 100%;
    max-width: 100%;
    margin-left: 0;
    margin-right: 0;
  }

  .form_block_login .signup-wizard-priv-table th,
  .form_block_login .signup-wizard-priv-table td {
    font-size: 0.7rem;
    padding: 6px 3px;
  }

  .form_block_login .signup-wizard-priv-table th {
    font-size: 0.75rem;
  }

  body.signupbg.signup-wizard-full-steps .login_form_right.signup-wizard-welcome-wide .col-sm-12.login_btn {
    width: 100%;
  }

  .form_block_login .login_btn input[type="submit"],
  .form_block_login .login_btn input[type="button"] {
    padding: 11px 12px;
    font-size: 0.875rem;
  }
}

/* -------------------------------------------------------------------------- */
/* signup-step-centered: body-class-independent vertical centering for steps  */
/* 2, 3, 4 and RegistrationResult. Works regardless of body class timing.     */
/* -------------------------------------------------------------------------- */

.sign_in_form_s.signup-step-centered {
  display: flex !important;
  flex-direction: column;
  flex: 1 1 auto;
  min-height: calc(100vh - 58px);
  min-height: calc(100dvh - 58px);
  align-items: stretch;
  align-content: stretch;
  box-sizing: border-box;
  background: #ffffff;
}

.sign_in_form_s.signup-step-centered>.login_section.bgsignup {
  flex: 1 1 auto;
  display: flex !important;
  align-items: center;
  justify-content: center;
  min-height: calc(100vh - 58px);
  min-height: calc(100dvh - 58px);
  width: 100%;
  box-sizing: border-box;
  background-color: #ffffff;
  padding: 24px 16px;
}

.sign_in_form_s.signup-step-centered .login_form_right {
  width: 100%;
  max-width: 580px;
  margin-left: auto;
  margin-right: auto;
  box-sizing: border-box;
}

.sign_in_form_s.signup-step-centered .login_form_right.signup-wizard-welcome-wide {
  max-width: 920px;
}

@media screen and (max-width: 575px) {
  .sign_in_form_s.signup-step-centered>.login_section.bgsignup {
    padding: 16px 12px;
    min-height: calc(100svh - 58px);
    align-items: flex-start;
  }

  .sign_in_form_s.signup-step-centered .login_form_right,
  .sign_in_form_s.signup-step-centered .login_form_right.signup-wizard-welcome-wide {
    max-width: 100%;
    padding-left: 0;
    padding-right: 0;
  }
}


@media screen and (max-width: 440px) {

  body.signupbg .login_fullhieght {
    padding: 40px 0px 0px !important;
  }

}`, "",{"version":3,"sources":["webpack://./src/ui/Pages/SignupPage/signup-wizard.css"],"names":[],"mappings":"AAAA,qDAAqD;;AAErD;EACE,kBAAkB;EAClB,iBAAiB;EACjB,kBAAkB;EAClB,aAAa;EACb,sBAAsB;AACxB;;AAEA,yBAAyB;AACzB;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,gBAAgB;EAChB,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,qCAAqC;EACrC,qDAAqD;AACvD;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;AACf;;AAEA,8FAA8F;AAC9F;;;;;;;;;;;;;;EAcE,oCAAoC;EACpC,wDAAwD;EACxD,wBAAwB;AAC1B;;AAEA;;;;;;;;;;;;;;EAcE,oCAAoC;EACpC,wDAAwD;EACxD,wBAAwB;AAC1B;;AAEA;;;EAGE,oCAAoC;EACpC,wDAAwD;AAC1D;;AAEA;;EAEE,oCAAoC;EACpC,wDAAwD;AAC1D;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,sBAAsB;EACtB,WAAW;EACX,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,YAAY;EACZ,cAAc;EACd,QAAQ;EACR,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,UAAU;AACZ;;AAEA;EACE,+BAA+B;EAC/B,eAAe;AACjB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,kBAAkB;EAClB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;EACf,cAAc;EACd,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,gCAAgC;AAClC;;AAEA;EACE,UAAU;EACV,SAAS;EACT,gBAAgB;EAChB,aAAa;EACb,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,0BAA0B;EAC1B,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,cAAc;EACd,oBAAoB;EACpB,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,cAAc;AAChB;;AAEA;;EAEE,WAAW;EACX,SAAO;EACP,WAAW;EACX,qCAAqC;AACvC;;AAEA;;EAEE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,2BAA2B;EAC3B,qCAAqC;EACrC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,UAAU;AACZ;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,2CAA2C;EAC3C,yBAAyB;EACzB,kBAAkB;EAClB,cAAc;EACd,wDAAwD;AAC1D;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,aAAa;EACb,SAAS;EACT,8BAA8B;EAC9B,oBAAoB;EACpB,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,SAAS;EACT,YAAY;EACZ,WAAW;EACX,eAAe;EACf,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,6BAA6B;EAC7B,8BAA8B;EAC9B,cAAc;EACd,0DAA0D;AAC5D;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,oCAAoC;AACtC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,gBAAgB;EAChB,YAAY;EACZ,0BAA0B;EAC1B,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,oCAAoC;EACpC,yBAAyB;EACzB,kBAAkB;EAClB,cAAc;EACd,wDAAwD;AAC1D;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,qBAAqB;AACvB;;AAEA,uFAAuF;AACvF;;;;;;EAME,oCAAoC;EACpC,wDAAwD;EACxD,wBAAwB;AAC1B;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,QAAQ;EACR,eAAe;EACf,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,UAAU;AACZ;;AAEA,uEAAuE;AACvE;;EAEE,cAAc;AAChB;;AAEA;;EAEE,cAAc;AAChB;;AAEA;;EAEE,cAAc;AAChB;;AAEA,6EAA6E;AAC7E;EACE,aAAa;AACf;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA,sCAAsC;AACtC;EACE,UAAU;AACZ;;AAEA;EACE,aAAa;AACf;;;AAGA;EACE,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,cAAc;AAChB;;AAEA;;EAEE,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;EAClB,cAAc;EACd,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;;EAEE,cAAc;AAChB;;;AAGA;EACE,gBAAgB;AAClB;;AAEA;;EAEE,wCAAwC;AAC1C;;AAEA;EACE,WAAW;AACb;;AAEA;;EAEE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,cAAc;EACd,eAAe;EACf,eAAe;EACf,UAAU;AACZ;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,aAAa;EACb,iBAAiB;AACnB;;AAEA,oEAAoE;AACpE;EACE,aAAa;EACb,mBAAmB;EACnB,UAAU;EACV,eAAe;EACf,YAAY;EACZ,kBAAkB;EAClB,oBAAoB;EACpB,cAAc;EACd,YAAY;EACZ,WAAW;EACX,8BAA8B;EAC9B,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA,sEAAsE;AACtE;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;AACV;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,0CAA0C;EAC1C,sBAAsB;EACtB,kBAAkB;EAClB,cAAc;EACd,wDAAwD;AAC1D;;AAEA;EACE;IACE,yBAAyB;EAC3B;AACF;;AAEA;;;EAGE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,cAAc;EACd,YAAY;EACZ,WAAW;EACX,8BAA8B;EAC9B,gBAAgB;EAChB,eAAe;AACjB;;AAEA;;;EAGE,YAAY;AACd;;AAEA;;;EAGE,aAAa;EACb,mBAAmB;AACrB;;AAEA,+EAA+E;AAC/E;;EAEE,0EAA0E;EAC1E,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,sBAAsB;AACxB;;AAEA;;EAEE,qBAAqB;EACrB,8BAA8B;EAC9B,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;;EAEE,qBAAqB;EACrB,eAAe;AACjB;;AAEA;;EAEE,wBAAwB;AAC1B;;AAEA,uDAAuD;AACvD;EACE,WAAW;EACX,YAAY;EACZ,qCAAqC;EACrC,yBAAyB;EACzB,kBAAkB;EAClB,cAAc;EACd,wDAAwD;AAC1D;;AAEA;EACE,iCAAiC;EACjC,yBAAyB;AAC3B;;AAEA,kFAAkF;AAClF;EACE,wBAAwB;EACxB,8BAA8B;EAC9B,sBAAsB;EACtB,YAAY;AACd;;AAEA,2FAA2F;AAC3F;EACE,0EAA0E;EAC1E,mBAAmB;AACrB;;AAEA;EACE,wBAAwB;EACxB,gDAAgD;EAChD,0CAA0C;AAC5C;;AAEA;EACE,2CAA2C;EAC3C,6DAA6D;EAC7D,UAAU;AACZ;;AAEA,mDAAmD;AACnD;EACE,wBAAwB;EACxB,8BAA8B;EAC9B,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,2CAA2C;EAC3C,UAAU;AACZ;;AAEA;EACE,qBAAqB;EACrB,sDAAsD;EACtD,cAAc;AAChB;;AAEA;EACE,gCAAgC;EAChC,kDAAkD;AACpD;;AAEA;EACE,oCAAoC;EACpC,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,gCAAgC;AAClC;;AAEA;EACE,cAAc;EACd,WAAW;EACX,gBAAgB;EAChB,YAAY;EACZ,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,0BAA0B;EAC1B,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,UAAU;AACZ;;;AAGA,+EAA+E;AAC/E,+EAA+E;AAC/E,+EAA+E;;AAE/E;EACE,aAAa;EACb,oBAAoB;EACpB,WAAW;EACX,gBAAgB;EAChB,mBAAmB;EACnB,2CAA2C;EAC3C,sBAAsB;EACtB,oDAAoD;EACpD,2CAA2C;AAC7C;;AAEA;EACE,yBAAyB;EACzB,6BAA6B;AAC/B;;AAEA,gEAAgE;AAChE;EACE,uCAAuC;EACvC,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,cAAc;EACd,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE;IACE,cAAc;EAChB;AACF;;AAEA;EACE,mBAAmB;EACnB,UAAU;EACV,cAAc;EACd,qCAAqC;EACrC,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,aAAa;EACb,oBAAoB;AACtB;;AAEA;EACE,SAAO;EACP,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,gBAAgB;EAChB,SAAS;EACT,YAAY;EACZ,gBAAgB;EAChB,uBAAuB;EACvB,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,2CAA2C;EAC3C,6DAA6D;EAC7D,UAAU;AACZ;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,2CAA2C;EAC3C,UAAU;AACZ;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,uBAAuB;AACzB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,mBAAmB;EACnB,2CAA2C;EAC3C,2CAA2C;EAC3C,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,2CAA2C;EAC3C,6DAA6D;EAC7D,UAAU;AACZ;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,2CAA2C;EAC3C,UAAU;AACZ;;AAEA;;;EAGE,oCAAoC;EACpC,wDAAwD;EACxD,wBAAwB;AAC1B;;AAEA;EACE,gBAAgB;EAChB,aAAa;AACf;;AAEA,gGAAgG;AAChG;EACE,oDAAoD;EACpD,gDAAgD;EAChD,oDAAoD;EACpD,iCAAiC;AACnC;;AAEA;EACE,sBAAsB;EACtB,iCAAiC;AACnC;;AAEA,+GAA+G;AAC/G;;EAEE,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,eAAe;;EAEf,gBAAgB;AAClB;;AAEA;;EAEE,gBAAgB;AAClB;;AAEA;;EAEE,gBAAgB;AAClB;;AAEA,uDAAuD;AACvD;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,wCAAwC;EACxC,uBAAuB;EACvB,2BAA2B;AAC7B;;AAEA;EACE,oCAAoC;EACpC,sDAAsD;AACxD;;AAEA;EACE,oCAAoC;EACpC,oCAAoC;AACtC;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,6BAA6B;AAC/B;;AAEA;;EAEE,sDAAsD;AACxD;;AAEA;EACE,cAAc;AAChB;;AAEA;;EAEE,oCAAoC;AACtC;;AAEA;EACE,gBAAgB;EAChB,qDAAqD;EACrD,cAAc;AAChB;;AAEA;EACE,sDAAsD;EACtD,cAAc;AAChB;;;AAGA,+EAA+E;AAC/E,8EAA8E;AAC9E,iFAAiF;AACjF,gFAAgF;AAChF,+EAA+E;;AAE/E;EACE,iBAAiB;EACjB,kBAAkB;EAClB,SAAS;EACT,qDAAqD;EACrD,sFAAsF;AACxF;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,yGAAyG;EACzG,8BAA8B;EAC9B,+BAA+B;EAC/B,aAAa;EACb,sBAAsB;EACtB,sBAAsB;EACtB,YAAY;EACZ,SAAS;AACX;;AAEA;EACE,mGAAmG;EACnG,aAAa;EACb,yCAAyC;EACzC,cAAc;EACd,WAAW;EACX,aAAa;EACb,gBAAgB;EAChB,oBAAoB;EACpB,sBAAsB;EACtB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,iBAAiB;EACjB,uBAAuB;EACvB,iCAAiC;EACjC,mBAAmB;EACnB,gBAAgB;EAChB,8BAA8B;EAC9B,+BAA+B;EAC/B,WAAW;EACX,eAAe;EACf,YAAY;EACZ,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,gBAAgB;EAChB,8BAA8B;EAC9B,+BAA+B;EAC/B,WAAW;EACX,YAAY;EACZ,eAAe;EACf,SAAS;EACT,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,iFAAiF;AACjF;EACE;IACE,mBAAmB;EACrB;;EAEA;IACE,0BAA0B;IAC1B,8BAA8B;IAC9B,+BAA+B;EACjC;;EAEA;IACE,8BAA8B;IAC9B,+BAA+B;IAC/B,eAAe;EACjB;AACF;;AAEA,4CAA4C;AAC5C;;EAEE;;;;IAIE,+BAA+B;EACjC;AACF;;AAEA,+EAA+E;AAC/E,gFAAgF;AAChF,+EAA+E;;AAE/E;EACE,mBAAmB;AACrB;;AAEA;EACE,qCAAqC;EACrC,eAAe;AACjB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,eAAe;EACf,WAAW;EACX,cAAc;EACd,iBAAiB;EACjB,uBAAuB;EACvB,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA,kFAAkF;AAClF;EACE,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,WAAW;AACb;;AAEA;;EAEE;IACE,aAAa;EACf;;EAEA;IACE,aAAa;IACb,YAAY;IACZ,WAAW;EACb;;EAEA;IACE,iBAAiB;EACnB;;AAEF;;;AAGA;;EAEE;IACE,iBAAiB;EACnB;;;EAGA;IACE,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;IAClB,mBAAmB;EACrB;AACF;;AAEA;EACE;IACE,kBAAkB;IAClB,iBAAiB;IACjB,iBAAiB;EACnB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,kBAAkB;IAClB,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,gBAAgB;EAClB;;EAEA;;IAEE,kBAAkB;IAClB,mBAAmB;EACrB;;EAEA;IACE,QAAQ;EACV;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,YAAY;IACZ,kBAAkB;EACpB;;EAEA;;IAEE,oBAAoB;IACpB,gBAAgB;EAClB;;EAEA;IACE,iBAAiB;EACnB;;;EAGA;IACE,eAAe;IACf,iBAAiB;IACjB,mBAAmB;IACnB,cAAc;EAChB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,oBAAoB;EACtB;;;EAGA;IACE,UAAU;IACV,eAAe;EACjB;;EAEA;IACE,gCAAgC;EAClC;;EAEA;IACE,iCAAiC;EACnC;;EAEA;IACE,iCAAiC;EACnC;;AAEF;;AAEA,kBAAkB;AAClB;;EAEE;IACE,SAAS;EACX;;EAEA;IACE,aAAa;IACb,iBAAiB;IACjB,QAAQ;IACR,gBAAgB;IAChB,iCAAiC;IACjC,qBAAqB;IACrB,mBAAmB;EACrB;;EAEA;IACE,iBAAiB;IACjB,sBAAsB;EACxB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,kBAAkB;IAClB,eAAe;EACjB;;EAEA;IACE,kBAAkB;IAClB,eAAe;EACjB;;EAEA;IACE,SAAS;EACX;;EAEA;;IAEE,kBAAkB;IAClB,mBAAmB;EACrB;;EAEA;IACE,oBAAoB;IACpB,mBAAmB;EACrB;;EAEA;IACE,QAAQ;EACV;;EAEA;IACE,YAAY;IACZ,kBAAkB;IAClB,kBAAkB;EACpB;;EAEA;IACE,oBAAoB;EACtB;;EAEA;IACE,eAAe;IACf,QAAQ;EACV;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,iBAAiB;IACjB,iBAAiB;IACjB,kBAAkB;EACpB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,WAAW;IACX,eAAe;IACf,cAAc;IACd,eAAe;EACjB;;EAEA;;IAEE,iBAAiB;IACjB,gBAAgB;EAClB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,WAAW;EACb;;EAEA;;IAEE,kBAAkB;IAClB,mBAAmB;EACrB;AACF;;AAEA,+EAA+E;AAC/E,+EAA+E;AAC/E,+EAA+E;AAC/E,+EAA+E;;AAE/E;EACE,wBAAwB;EACxB,sBAAsB;EACtB,cAAc;EACd,8BAA8B;EAC9B,+BAA+B;EAC/B,oBAAoB;EACpB,sBAAsB;EACtB,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,wBAAwB;EACxB,mBAAmB;EACnB,uBAAuB;EACvB,8BAA8B;EAC9B,+BAA+B;EAC/B,WAAW;EACX,sBAAsB;EACtB,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE;IACE,kBAAkB;IAClB,+BAA+B;IAC/B,uBAAuB;EACzB;;EAEA;;IAEE,eAAe;IACf,eAAe;IACf,gBAAgB;EAClB;AACF;;;AAGA;;EAEE;IACE,gCAAgC;EAClC;;AAEF","sourcesContent":["/* Scoped to signup wizard inside .form_block_login */\n\n.form_block_login .signup-wizard-step-meta {\n  text-align: center;\n  font-size: 0.8rem;\n  margin: -4px 0 8px;\n  opacity: 0.65;\n  letter-spacing: 0.02em;\n}\n\n/* Step indicator (1–4) */\n.form_block_login .signup-wizard-steps-bar {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 10px;\n  margin: 0 0 18px;\n  padding: 0;\n  list-style: none;\n}\n\n.form_block_login .signup-wizard-steps-bar li {\n  width: 10px;\n  height: 10px;\n  border-radius: 50%;\n  background: rgba(255, 255, 255, 0.22);\n  transition: transform 0.2s ease, background 0.2s ease;\n}\n\nbody.light_theme .form_block_login .signup-wizard-steps-bar li {\n  background: rgba(0, 0, 0, 0.15);\n}\n\n.form_block_login .signup-wizard-steps-bar li.is-done {\n  background: rgba(209, 170, 103, 0.55);\n}\n\n.form_block_login .signup-wizard-steps-bar li.is-active {\n  background: #d1aa67;\n  transform: scale(1.25);\n}\n\nbody.light_theme .form_block_login .signup-wizard-steps-bar li.is-active {\n  background: #c49a4e;\n}\n\nbody.light_theme .form_block_login .signup-wizard-step-meta {\n  opacity: 0.55;\n}\n\n/* Step 1 email: danger border — must beat public/style.css focus rule (border … !important) */\n.login_section .form_block_login .email_code.eids-email-wrap.signup-step1-email--error .input_filed,\n.login_section .form_block_login .eids-email-wrap.signup-step1-email--error .input_filed,\n.login_fullhieght .login_section .form_block_login .email_code.eids-email-wrap.signup-step1-email--error .input_filed,\n.login_fullhieght .login_section .form_block_login .eids-email-wrap.signup-step1-email--error .input_filed,\n.form_block_login .email_code.eids-email-wrap.signup-step1-email--error .input_filed,\n.form_block_login .eids-email-wrap.signup-step1-email--error .input_filed,\n.login_section .form_block_login .email_code.eids-email-wrap.signup-step1-email--error .input_filed:focus,\n.login_section .form_block_login .email_code.eids-email-wrap.signup-step1-email--error .input_filed:focus-visible,\n.login_section .form_block_login .eids-email-wrap.signup-step1-email--error .input_filed:focus,\n.login_section .form_block_login .eids-email-wrap.signup-step1-email--error .input_filed:focus-visible,\n.login_fullhieght .login_section .form_block_login .email_code.eids-email-wrap.signup-step1-email--error .input_filed:focus,\n.login_fullhieght .login_section .form_block_login .email_code.eids-email-wrap.signup-step1-email--error .input_filed:focus-visible,\n.login_fullhieght .login_section .form_block_login .eids-email-wrap.signup-step1-email--error .input_filed:focus,\n.login_fullhieght .login_section .form_block_login .eids-email-wrap.signup-step1-email--error .input_filed:focus-visible {\n  border: 1px solid #dc2626 !important;\n  box-shadow: 0 0 0 1px rgba(220, 38, 38, 0.25) !important;\n  outline: none !important;\n}\n\nbody.light_theme .login_section .form_block_login .email_code.eids-email-wrap.signup-step1-email--error .input_filed,\nbody.light_theme .login_section .form_block_login .eids-email-wrap.signup-step1-email--error .input_filed,\nbody.light_theme .login_fullhieght .login_section .form_block_login .email_code.eids-email-wrap.signup-step1-email--error .input_filed,\nbody.light_theme .login_fullhieght .login_section .form_block_login .eids-email-wrap.signup-step1-email--error .input_filed,\nbody.light_theme .login_section .form_block_login .email_code.eids-email-wrap.signup-step1-email--error .input_filed:focus,\nbody.light_theme .login_section .form_block_login .email_code.eids-email-wrap.signup-step1-email--error .input_filed:focus-visible,\nbody.light_theme .login_section .form_block_login .eids-email-wrap.signup-step1-email--error .input_filed:focus,\nbody.light_theme .login_section .form_block_login .eids-email-wrap.signup-step1-email--error .input_filed:focus-visible,\nbody.light_theme .login_fullhieght .login_section .form_block_login .email_code.eids-email-wrap.signup-step1-email--error .input_filed,\nbody.light_theme .login_fullhieght .login_section .form_block_login .eids-email-wrap.signup-step1-email--error .input_filed,\nbody.light_theme .login_fullhieght .login_section .form_block_login .email_code.eids-email-wrap.signup-step1-email--error .input_filed:focus,\nbody.light_theme .login_fullhieght .login_section .form_block_login .email_code.eids-email-wrap.signup-step1-email--error .input_filed:focus-visible,\nbody.light_theme .login_fullhieght .login_section .form_block_login .eids-email-wrap.signup-step1-email--error .input_filed:focus,\nbody.light_theme .login_fullhieght .login_section .form_block_login .eids-email-wrap.signup-step1-email--error .input_filed:focus-visible {\n  border: 1px solid #dc2626 !important;\n  box-shadow: 0 0 0 1px rgba(220, 38, 38, 0.25) !important;\n  outline: none !important;\n}\n\n.login_section .form_block_login .auth-phone-field.signup-step1-phone--error,\n.login_fullhieght .login_section .form_block_login .auth-phone-field.signup-step1-phone--error,\n.form_block_login .auth-phone-field.signup-step1-phone--error {\n  border: 1px solid #dc2626 !important;\n  box-shadow: 0 0 0 1px rgba(220, 38, 38, 0.25) !important;\n}\n\nbody.light_theme .login_section .form_block_login .auth-phone-field.signup-step1-phone--error,\nbody.light_theme .login_fullhieght .login_section .form_block_login .auth-phone-field.signup-step1-phone--error {\n  border: 1px solid #dc2626 !important;\n  box-shadow: 0 0 0 1px rgba(220, 38, 38, 0.25) !important;\n}\n\n.form_block_login .signup-wizard-referral-toggle {\n  display: flex;\n  align-items: center;\n  justify-content: start;\n  width: 100%;\n  padding: 10px 0 0px;\n  margin-bottom: 0px;\n  background: none;\n  border: none;\n  color: inherit;\n  gap: 5px;\n  font-size: 14px;\n  cursor: pointer;\n  text-align: left;\n  opacity: 1;\n}\n\n.form_block_login .signup-wizard-referral-toggle i {\n  transition: transform 0.2s ease;\n  font-size: 18px;\n}\n\n.form_block_login .signup-wizard-referral-toggle.is-open i {\n  transform: rotate(180deg);\n}\n\n.form_block_login .signup-wizard-agree {\n  display: flex;\n  align-items: flex-start;\n  gap: 10px;\n  margin: 14px 0 4px;\n  font-size: 13px;\n  line-height: 1.5;\n}\n\n.form_block_login .signup-wizard-agree input[type=\"checkbox\"] {\n  width: 16px;\n  height: 16px;\n  margin-top: 2px;\n  flex-shrink: 0;\n  cursor: pointer;\n  accent-color: #CBA763;\n}\n\n.form_block_login .signup-wizard-agree label {\n  margin: 0;\n  cursor: pointer;\n  color: #A0A3A7;\n}\n\n.form_block_login .signup-wizard-agree a {\n  color: #CBA763;\n  /* text-decoration: underline; */\n}\n\n.form_block_login .signup-wizard-agree__link {\n  padding: 0;\n  border: 0;\n  background: none;\n  font: inherit;\n  color: #CBA763;\n  cursor: pointer;\n}\n\n.form_block_login .signup-wizard-agree__link:hover {\n  text-decoration: underline;\n}\n\n.form_block_login .signup-wizard-agree--error label {\n  color: #f6465d;\n}\n\n.form_block_login .signup-wizard-agree--error input[type=\"checkbox\"] {\n  outline: 1px solid #f6465d;\n  outline-offset: 2px;\n  border-radius: 3px;\n}\n\nbody.light_theme .form_block_login .signup-wizard-agree label {\n  color: #4A5565;\n}\n\nbody.light_theme .form_block_login .signup-wizard-agree--error label {\n  color: #f6465d;\n}\n\n.form_block_login .signup-wizard-divider {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  color: #a6a6a6;\n  margin: 5px 0px 20px;\n  font-size: 0.85rem;\n  opacity: 0.8;\n}\n\nbody.light_theme .form_block_login .signup-wizard-divider {\n  color: #525252;\n}\n\n.form_block_login .signup-wizard-divider::before,\n.form_block_login .signup-wizard-divider::after {\n  content: \"\";\n  flex: 1;\n  height: 1px;\n  background: rgba(255, 255, 255, 0.25);\n}\n\nbody.light_theme .form_block_login .signup-wizard-divider::before,\nbody.light_theme .form_block_login .signup-wizard-divider::after {\n  background: #e5e5e5;\n}\n\n.form_block_login .signup-wizard-social-row {\n  display: flex;\n  justify-content: center;\n  gap: 52px;\n  margin-bottom: 8px;\n}\n\n.form_block_login .signup-wizard-social-btn {\n  width: 48px;\n  height: 48px;\n  border-radius: 12px;\n  border: 1px solid #f2f3f40f;\n  background: rgba(255, 255, 255, 0.06);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  padding: 0;\n}\n\nbody.light_theme .form_block_login .signup-wizard-social-btn {\n  border: 1px solid #F2F3F4;\n}\n\n.form_block_login .signup-wizard-social-btn img {\n  width: 24px;\n  height: 24px;\n  object-fit: contain;\n}\n\n.form_block_login .signup-wizard-social-btn:disabled {\n  opacity: 0.8;\n  cursor: not-allowed;\n}\n\n.form_block_login .signup-social-btn__spinner {\n  width: 22px;\n  height: 22px;\n  border: 2px solid rgba(209, 170, 103, 0.35);\n  border-top-color: #d1aa67;\n  border-radius: 50%;\n  flex-shrink: 0;\n  animation: signup-wizard-next-spin 0.65s linear infinite;\n}\n\nbody.light_theme .form_block_login .signup-wizard-social-btn {\n  border-color: rgb(0 0 0 / 4%);\n}\n\n.form_block_login .signup-wizard-otp-stack {\n  width: 100%;\n}\n\n.form_block_login .signup-wizard-otp-row {\n  display: flex;\n  gap: 10px;\n  justify-content: space-between;\n  align-items: stretch;\n  margin-bottom: 10px;\n  flex-wrap: nowrap;\n}\n\n.form_block_login .signup-wizard-otp-cell {\n  flex: 1 1;\n  min-width: 0;\n  width: 100%;\n  max-width: 50px;\n  height: 58px;\n  text-align: center;\n  font-size: 1.15rem;\n  font-weight: 700;\n  border-radius: 10px;\n  border: 1px solid transparent;\n  background: #323232 !important;\n  color: inherit;\n  transition: border-color 0.15s ease, background 0.15s ease;\n}\n\nbody.light_theme .form_block_login .signup-wizard-otp-cell {\n  background: #F5F6F7 !important;\n}\n\n.form_block_login .signup-wizard-otp-cell:focus {\n  outline: none;\n  border: 1px solid #1a1a1a !important;\n}\n\nbody.light_theme .form_block_login .signup-wizard-otp-cell {\n  background: #f2f3f4;\n}\n\nbody.light_theme .form_block_login .signup-wizard-otp-cell:focus {\n  border: 1px solid #1a1a1a !important;\n}\n\n.form_block_login .signup-wizard-otp-actions {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 16px;\n  width: 100%;\n}\n\n.form_block_login .signup-wizard-otp-link {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 4px;\n  background: none;\n  border: none;\n  text-decoration: underline;\n  cursor: pointer;\n  font-size: 15px;\n  font-weight: 500;\n  color: #e4e4e4;\n  /* opacity: 0.9; */\n  padding: 0;\n}\n\nbody.light_theme .form_block_login .signup-wizard-otp-link {\n  color: #070808;\n}\n\n.form_block_login .signup-otp-link__spinner {\n  width: 14px;\n  height: 14px;\n  border: 2px solid rgba(7, 8, 8, 0.2);\n  border-top-color: #070808;\n  border-radius: 50%;\n  flex-shrink: 0;\n  animation: signup-wizard-next-spin 0.65s linear infinite;\n}\n\n.form_block_login .signup-wizard-otp-link:disabled {\n  opacity: 0.4;\n  cursor: not-allowed;\n  text-decoration: none;\n}\n\n.form_block_login .signup-wizard-otp-paste {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  text-decoration: none;\n}\n\n.form_block_login .signup-wizard-otp-paste i {\n  font-size: 1rem;\n  text-decoration: none;\n}\n\n/* OTP error: must override .signup-wizard-otp-cell:focus (border #1a1a1a !important) */\n.form_block_login .signup-wizard-otp-stack--error .signup-wizard-otp-cell,\n.form_block_login .signup-wizard-otp-stack--error .signup-wizard-otp-cell:focus,\n.form_block_login .signup-wizard-otp-stack--error .signup-wizard-otp-cell:focus-visible,\nbody.light_theme .form_block_login .signup-wizard-otp-stack--error .signup-wizard-otp-cell,\nbody.light_theme .form_block_login .signup-wizard-otp-stack--error .signup-wizard-otp-cell:focus,\nbody.light_theme .form_block_login .signup-wizard-otp-stack--error .signup-wizard-otp-cell:focus-visible {\n  border: 1px solid #dc2626 !important;\n  box-shadow: 0 0 0 1px rgba(220, 38, 38, 0.25) !important;\n  outline: none !important;\n}\n\n.form_block_login .signup-wizard-rule-list {\n  transition: opacity 0.2s ease;\n}\n\n.form_block_login .signup-wizard-rule-list--empty {\n  opacity: 0.90;\n}\n\n.form_block_login .signup-wizard-rule-list:not(.signup-wizard-rule-list--empty) {\n  opacity: 1;\n}\n\n.form_block_login .signup-wizard-rule-row {\n  display: flex;\n  align-items: flex-start;\n  gap: 5px;\n  font-size: 12px;\n  margin-bottom: 0px;\n  opacity: 0.9;\n}\n\n.form_block_login .signup-wizard-rule-list:not(.signup-wizard-rule-list--empty) .signup-wizard-rule-row {\n  opacity: 1;\n}\n\n/* Legacy class names; new rows use --ok / --bad / --pending / --idle */\n.form_block_login .signup-wizard-rule-row.is-ok i,\n.form_block_login .signup-wizard-rule-row--ok i {\n  color: #f3f3f3;\n}\n\nbody.light_theme .form_block_login .signup-wizard-rule-row.is-ok i,\nbody.light_theme .form_block_login .signup-wizard-rule-row--ok i {\n  color: #161616;\n}\n\n.form_block_login .signup-wizard-rule-row.is-bad i,\n.form_block_login .signup-wizard-rule-row--bad i {\n  color: #b91c1c;\n}\n\n/* Rules after the first failure: not yet required until earlier steps pass */\n.form_block_login .signup-wizard-rule-row--pending {\n  opacity: 0.55;\n}\n\n.form_block_login .signup-wizard-rule-row--pending i {\n  color: #e1e1e1;\n}\n\nbody.light_theme .form_block_login .signup-wizard-rule-row--pending i {\n  color: #8f9299;\n}\n\n.form_block_login .signup-wizard-rule-row--pending span {\n  color: #eeeeee;\n}\n\nbody.light_theme .form_block_login .signup-wizard-rule-row--pending span {\n  color: #6b7280;\n}\n\n/* Empty password: all rules neutral */\n.form_block_login .signup-wizard-rule-list--empty .signup-wizard-rule-row--idle {\n  opacity: 1;\n}\n\nbody.light_theme .form_block_login .signup-wizard-rule-list--empty .signup-wizard-rule-row--idle {\n  opacity: 0.85;\n}\n\n\n.form_block_login .signup-wizard-rule-row--idle i {\n  color: #9ca3af;\n}\n\n.form_block_login .signup-wizard-priv-table {\n  width: 650px;\n  max-width: 100%;\n  margin: 0px auto;\n  margin-bottom: 20px;\n  border-collapse: collapse;\n  font-size: 14px;\n}\n\nbody.signupbg.signup-wizard-full-steps .login_form_right.signup-wizard-welcome-wide .col-sm-12.login_btn {\n  width: 670px;\n  max-width: 100%;\n  margin: 0 auto;\n}\n\n.form_block_login .signup-wizard-priv-table th,\n.form_block_login .signup-wizard-priv-table td {\n  padding: 10px 8px;\n  border-bottom: none;\n  text-align: center;\n  color: #a5a5a5;\n  font-weight: 600;\n  font-size: 20px;\n}\n\n.form_block_login .signup-wizard-priv-table td img {\n  filter: invert(1);\n}\n\nbody.light_theme .form_block_login .signup-wizard-priv-table td img {\n  filter: invert(0);\n}\n\nbody.light_theme .form_block_login .signup-wizard-priv-table th,\nbody.light_theme .form_block_login .signup-wizard-priv-table td {\n  color: #303236;\n}\n\n\n.form_block_login .signup-wizard-priv-table td strong {\n  font-weight: 600;\n}\n\nbody.light_theme .form_block_login .signup-wizard-priv-table th,\nbody.light_theme .form_block_login .signup-wizard-priv-table td {\n  border-bottom-color: rgba(0, 0, 0, 0.08);\n}\n\nbody.light_theme .form_block_login .signup-wizard-priv-table td i.ri-check-line {\n  color: #000;\n}\n\n.form_block_login .signup-wizard-priv-table th:first-child,\n.form_block_login .signup-wizard-priv-table td:first-child {\n  text-align: left;\n}\n\n.form_block_login .signup-wizard-priv-table th {\n  font-weight: 400;\n  color: #84878A;\n  font-size: 24px;\n}\n\nh3.mb-2.verify_hd {\n  font-size: 29px;\n  line-height: 140%;\n  font-weight: 600;\n  margin-top: -110px;\n}\n\nh3.mb-2.verify_hd span {\n  color: #D1AA67;\n}\n\n.form_block_login .signup-wizard-welcome-img {\n  text-align: center;\n  margin: 12px 0px;\n}\n\n.form_block_login .signup-wizard-welcome-img img {\n  max-width: 220px;\n  height: auto;\n}\n\n.form_block_login .signup-wizard-secure {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n  color: #9FA2A5;\n  font-size: 14px;\n  margin-top: 1px;\n  opacity: 1;\n}\n\n.form_block_login .signup-wizard-subtitle {\n  font-size: 0.9rem;\n  margin: 0 0 16px;\n  opacity: 0.75;\n  line-height: 1.45;\n}\n\n/* Match .login_btn primary actions for button.next_btn and submit */\n.form_block_login .login_btn button.next_btn {\n  padding: 17px;\n  border-radius: 50px;\n  right: 0px;\n  cursor: pointer;\n  height: auto;\n  position: relative;\n  pointer-events: auto;\n  color: #ffffff;\n  border: none;\n  width: 100%;\n  background: #303236 !important;\n  font-weight: 500;\n  font-size: 16px;\n}\n\n.form_block_login .login_btn button.next_btn:hover:not(:disabled) {\n  opacity: 0.9;\n}\n\n.form_block_login .login_btn button.next_btn:disabled {\n  opacity: 0.45;\n  cursor: not-allowed;\n}\n\n/* Step 1: Next button inline loader during email/referral API check */\n.form_block_login .login_btn button.next_btn.signup-next-btn {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n}\n\n.form_block_login .signup-next-btn__spinner {\n  width: 16px;\n  height: 16px;\n  border: 2px solid rgba(255, 255, 255, 0.4);\n  border-top-color: #fff;\n  border-radius: 50%;\n  flex-shrink: 0;\n  animation: signup-wizard-next-spin 0.65s linear infinite;\n}\n\n@keyframes signup-wizard-next-spin {\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n.form_block_login .login_btn input[type=\"submit\"],\n.form_block_login .login_btn input[type=\"button\"],\n.form_block_login .login_btn button.signup-wizard-confirm-password {\n  padding: 12px;\n  border-radius: 50px;\n  cursor: pointer;\n  color: #ffffff;\n  border: none;\n  width: 100%;\n  background: #1a1d21 !important;\n  font-weight: 500;\n  font-size: 16px;\n}\n\n.form_block_login .login_btn input[type=\"submit\"]:hover:not(:disabled),\n.form_block_login .login_btn input[type=\"button\"]:hover:not(:disabled),\n.form_block_login .login_btn button.signup-wizard-confirm-password:hover:not(:disabled) {\n  opacity: 0.9;\n}\n\n.form_block_login .login_btn input[type=\"submit\"]:disabled,\n.form_block_login .login_btn input[type=\"button\"]:disabled,\n.form_block_login .login_btn button.signup-wizard-confirm-password:disabled {\n  opacity: 0.45;\n  cursor: not-allowed;\n}\n\n/* Password step — Confirm: faded until user types (match light reference UI) */\n.form_block_login .login_btn input[type=\"button\"].signup-wizard-confirm-password,\n.form_block_login .login_btn button.signup-wizard-confirm-password {\n  transition: opacity 0.2s ease, background-color 0.2s ease, color 0.2s ease;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n  box-sizing: border-box;\n}\n\n.form_block_login .login_btn input[type=\"button\"].signup-wizard-confirm-password:disabled,\n.form_block_login .login_btn button.signup-wizard-confirm-password:disabled {\n  opacity: 1 !important;\n  background: #343434 !important;\n  color: #e9e9e9 !important;\n  cursor: not-allowed;\n}\n\n.form_block_login .login_btn input[type=\"button\"].signup-wizard-confirm-password:not(:disabled),\n.form_block_login .login_btn button.signup-wizard-confirm-password:not(:disabled) {\n  opacity: 1 !important;\n  cursor: pointer;\n}\n\n.form_block_login .login_btn input[type=\"button\"].signup-wizard-confirm-password:not(:disabled):hover,\n.form_block_login .login_btn button.signup-wizard-confirm-password:not(:disabled):hover {\n  opacity: 0.92 !important;\n}\n\n/* Gold Confirm — inline spinner (dark on light/gold) */\n.form_block_login .signup-confirm-btn__spinner {\n  width: 16px;\n  height: 16px;\n  border: 2px solid rgba(0, 0, 0, 0.12);\n  border-top-color: #1a1a1a;\n  border-radius: 50%;\n  flex-shrink: 0;\n  animation: signup-wizard-next-spin 0.65s linear infinite;\n}\n\n.form_block_login .login_btn button.signup-wizard-confirm-password:not(:disabled) .signup-confirm-btn__spinner {\n  border-color: rgba(0, 0, 0, 0.18);\n  border-top-color: #1a1a1a;\n}\n\n/* While API runs — stay readable (not the same as “invalid password” dim state) */\n.form_block_login .login_btn button.signup-wizard-confirm-password.signup-wizard-confirm-password--busy:disabled {\n  opacity: 0.95 !important;\n  background: #1a1d21 !important;\n  color: #000 !important;\n  cursor: wait;\n}\n\n/* Password step — input: same faded \"empty\" look as Confirm; eye only when value present */\n.form_block_login .signup-wizard-password-field .input_filed {\n  transition: opacity 0.2s ease, background-color 0.2s ease, color 0.2s ease;\n  border-radius: 12px;\n}\n\n.form_block_login .signup-wizard-password-field--empty .input_filed {\n  opacity: 0.55 !important;\n  background: rgba(255, 255, 255, 0.07) !important;\n  color: rgba(200, 200, 200, 0.8) !important;\n}\n\n.form_block_login .signup-wizard-password-field--empty .input_filed::placeholder {\n  color: rgba(200, 200, 200, 0.65) !important;\n  -webkit-text-fill-color: rgba(200, 200, 200, 0.65) !important;\n  opacity: 1;\n}\n\n/* Light theme overrides for empty password field */\nbody.light_theme .form_block_login .signup-wizard-password-field--empty .input_filed {\n  opacity: 0.80 !important;\n  background: #e4e5e7 !important;\n  color: #666666 !important;\n}\n\nbody.light_theme .form_block_login .signup-wizard-password-field--empty .input_filed::placeholder {\n  color: #a8adb4 !important;\n  -webkit-text-fill-color: #a8adb4 !important;\n  opacity: 1;\n}\n\n.form_block_login .signup-wizard-password-field:not(.signup-wizard-password-field--empty) .input_filed {\n  opacity: 1 !important;\n  background-color: rgba(255, 255, 255, 0.06) !important;\n  color: #e0e0e0;\n}\n\n.form_block_login .signup-wizard-password-field:not(.signup-wizard-password-field--empty) .input_filed::placeholder {\n  color: rgba(200, 200, 200, 0.65);\n  -webkit-text-fill-color: rgba(200, 200, 200, 0.65);\n}\n\nbody.light_theme .form_block_login .signup-wizard-password-field:not(.signup-wizard-password-field--empty) .input_filed {\n  background-color: #f5f6f7 !important;\n  color: #1a1d21 !important;\n}\n\nbody.light_theme .form_block_login .signup-wizard-password-field:not(.signup-wizard-password-field--empty) .input_filed::placeholder {\n  color: #84888c;\n  -webkit-text-fill-color: #84888c;\n}\n\n.form_block_login .signup-wizard-back {\n  display: block;\n  width: 100%;\n  margin-top: 12px;\n  padding: 0px;\n  background: none;\n  border: none;\n  cursor: pointer;\n  text-decoration: underline;\n  font-size: 14px;\n  color: #070808;\n  font-weight: 500;\n  opacity: 1;\n}\n\n\n/* -------------------------------------------------------------------------- */\n/* Unified phone row + referral pill (signup + login)                         */\n/* -------------------------------------------------------------------------- */\n\n.form_block_login .auth-phone-field {\n  display: flex;\n  align-items: stretch;\n  width: 100%;\n  min-height: 53px;\n  border-radius: 12px;\n  background-color: rgba(255, 255, 255, 0.05);\n  box-sizing: border-box;\n  /* Reserve 2px so focus ring does not shift layout */\n  border: 1px solid rgba(245, 246, 247, 0.25);\n}\n\nbody.light_theme .form_block_login .auth-phone-field {\n  background-color: #f5f6f7;\n  border: 1px solid transparent;\n}\n\n/* Full-row focus: country + divider + number (login + signup) */\n.form_block_login .auth-phone-field.auth-phone-field--unified:focus-within {\n  border-color: rgba(255, 255, 255, 0.35);\n  box-shadow: none;\n  outline: none;\n}\n\nbody.light_theme .form_block_login .auth-phone-field.auth-phone-field--unified:focus-within {\n  border-color: #343539;\n}\n\n.form_block_login .auth-phone-field__country {\n  flex: 0 0 auto;\n  min-width: 0;\n  max-width: 46%;\n  display: flex;\n  align-items: center;\n}\n\n@media screen and (max-width: 400px) {\n  .form_block_login .auth-phone-field__country {\n    max-width: 52%;\n  }\n}\n\n.form_block_login .auth-phone-field__divider {\n  align-self: stretch;\n  width: 1px;\n  min-width: 1px;\n  background: rgba(150, 155, 160, 0.35);\n  margin: 10px 0;\n  flex-shrink: 0;\n}\n\nbody.light_theme .form_block_login .auth-phone-field__divider {\n  background: #dfe2e6;\n}\n\n.form_block_login .auth-phone-field__number {\n  flex: 1 1 auto;\n  min-width: 0;\n  display: flex;\n  align-items: stretch;\n}\n\n.form_block_login .auth-phone-field__input.input_filed {\n  flex: 1;\n  width: 100%;\n  min-width: 0;\n  height: auto;\n  min-height: 53px;\n  margin: 0;\n  border: none;\n  border-radius: 0;\n  background: transparent;\n  box-shadow: none;\n  padding-left: 10px;\n  padding-right: 14px;\n  color: #e0e0e0;\n}\n\n.form_block_login .auth-phone-field__input.input_filed::placeholder {\n  color: rgba(200, 200, 200, 0.65) !important;\n  -webkit-text-fill-color: rgba(200, 200, 200, 0.65) !important;\n  opacity: 1;\n}\n\nbody.light_theme .form_block_login .auth-phone-field__input.input_filed {\n  color: #1a1d21;\n}\n\nbody.light_theme .form_block_login .auth-phone-field__input.input_filed::placeholder {\n  color: #84888c !important;\n  -webkit-text-fill-color: #84888c !important;\n  opacity: 1;\n}\n\n.form_block_login .auth-phone-field__input.input_filed:focus {\n  outline: none;\n}\n\n.form_block_login .auth-phone-country-inner {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  white-space: nowrap;\n}\n\n.form_block_login .auth-phone-country-flag {\n  font-size: 1.1rem;\n  line-height: 1;\n}\n\n.form_block_login .auth-phone-country-code {\n  font-weight: 500;\n  font-size: 14px;\n  letter-spacing: -0.01em;\n}\n\n.form_block_login .auth-referral-field {\n  margin-top: 8px;\n}\n\nh5#exampleModalLabel {\n  font-size: 24px;\n  font-weight: 600;\n}\n\n#VerificationOptionsModal .modal-header p {\n  font-size: 16px;\n  color: #515254;\n}\n\n#VerificationOptionsModal .modal.fade .modal-dialog {\n  min-width: 700px;\n}\n\nform.profile_form strong {\n  font-size: 20px;\n  font-weight: 500;\n}\n\nform.profile_form i {\n  font-size: 20px !important;\n}\n\nform.profile_form .small {\n  font-size: 16px;\n}\n\n.form_block_login .auth-referral-field .input_filed {\n  width: 100%;\n  border-radius: 12px;\n  background-color: rgba(255, 255, 255, 0.05);\n  border: 1px solid rgba(245, 246, 247, 0.25);\n  height: 53px;\n  color: #e0e0e0;\n}\n\n.form_block_login .auth-referral-field .input_filed::placeholder {\n  color: rgba(200, 200, 200, 0.65) !important;\n  -webkit-text-fill-color: rgba(200, 200, 200, 0.65) !important;\n  opacity: 1;\n}\n\nbody.light_theme .form_block_login .auth-referral-field .input_filed {\n  background-color: #f5f6f7;\n  border: none;\n  color: #1a1d21;\n}\n\nbody.light_theme .form_block_login .auth-referral-field .input_filed::placeholder {\n  color: #84888c !important;\n  -webkit-text-fill-color: #84888c !important;\n  opacity: 1;\n}\n\n.form_block_login .auth-referral-field.auth-referral-field--error .input_filed,\n.form_block_login .auth-referral-field.auth-referral-field--error .input_filed:focus,\n.form_block_login .auth-referral-field.auth-referral-field--error .input_filed:focus-visible {\n  border: 1px solid #dc2626 !important;\n  box-shadow: 0 0 0 1px rgba(220, 38, 38, 0.25) !important;\n  outline: none !important;\n}\n\n.form_block_login .signup-wizard-referral-optional {\n  font-weight: 500;\n  opacity: 0.55;\n}\n\n/* React Select: country menu is portaled to body — enforce readable width (not control width) */\nbody .auth-phone-country__menu {\n  min-width: min(calc(100vw - 24px), 360px) !important;\n  width: min(calc(100vw - 24px), 360px) !important;\n  max-width: min(calc(100vw - 24px), 360px) !important;\n  box-sizing: border-box !important;\n}\n\nbody .auth-phone-country__menu-list {\n  width: 100% !important;\n  box-sizing: border-box !important;\n}\n\n/* Login + Signup routes: bump weights to match deposit/withdraw ladder (global form rules live in style.css) */\nbody.loginbg .form_block_login h2,\nbody.signupbg .form_block_login h2 {\n  font-weight: 600;\n  font-size: 32px;\n}\n\nbody .passkey-modal--loginPasskey .passkey-modal__subtitle {\n  font-size: 16px;\n\n  font-weight: 400;\n}\n\nbody.loginbg .form_block_login label,\nbody.signupbg .form_block_login label {\n  font-weight: 500;\n}\n\nbody.loginbg .login_section .nav.nav-tabs li button,\nbody.signupbg .login_section .nav.nav-tabs li button {\n  font-weight: 500;\n}\n\n/* Phone country react-select (menu portaled to body) */\nbody .auth-phone-country__single-value {\n  font-weight: 500;\n  color: #e0e0e0;\n}\n\nbody.light_theme .auth-phone-country__single-value {\n  color: #1a1d21;\n}\n\nbody .auth-phone-country__control {\n  background-color: transparent !important;\n  border: none !important;\n  box-shadow: none !important;\n}\n\nbody .auth-phone-country__menu {\n  background-color: #1e2026 !important;\n  border: 1px solid rgba(255, 255, 255, 0.12) !important;\n}\n\nbody.light_theme .auth-phone-country__menu {\n  background-color: #ffffff !important;\n  border: 1px solid #e5e7eb !important;\n}\n\nbody .auth-phone-country__option {\n  font-weight: 500;\n  color: #e0e0e0;\n  background-color: transparent;\n}\n\nbody .auth-phone-country__option:hover,\nbody .auth-phone-country__option--is-focused {\n  background-color: rgba(255, 255, 255, 0.08) !important;\n}\n\nbody.light_theme .auth-phone-country__option {\n  color: #1a1d21;\n}\n\nbody.light_theme .auth-phone-country__option:hover,\nbody.light_theme .auth-phone-country__option--is-focused {\n  background-color: #f3f4f6 !important;\n}\n\nbody .auth-phone-country__option--is-selected {\n  font-weight: 600;\n  background-color: rgba(209, 170, 103, 0.2) !important;\n  color: #D1AA67;\n}\n\nbody.light_theme .auth-phone-country__option--is-selected {\n  background-color: rgba(209, 170, 103, 0.15) !important;\n  color: #a07830;\n}\n\n\n/* -------------------------------------------------------------------------- */\n/* Signup split layout: fill viewport (no strip below black / white columns) */\n/* Root cause: .sign_in_form_s used align-items: center so columns did not      */\n/* stretch to full viewport height.                                            */\n/* -------------------------------------------------------------------------- */\n\nbody.signupbg {\n  min-height: 100vh;\n  min-height: 100dvh;\n  margin: 0;\n  /* Fallback behind columns if anything is 1px short */\n  background: linear-gradient(90deg, #000000 0%, #000000 50%, #000000 50%, #000000 100%);\n}\n\nbody.signupbg #root {\n  min-height: 100vh;\n  min-height: 100dvh;\n  display: flex;\n  flex-direction: column;\n  box-sizing: border-box;\n}\n\nbody.signupbg .login_fullhieght {\n  flex: 1 1 auto;\n  width: 100%;\n  /* Match visible area below fixed header (see style.css #root:has(header.sticky-top) padding-top: 58px) */\n  min-height: calc(100vh - 58px);\n  min-height: calc(100dvh - 58px);\n  display: flex;\n  flex-direction: column;\n  box-sizing: border-box;\n  padding: 0px;\n  margin: 0;\n}\n\nbody.signupbg .sign_in_form_s {\n  /* Left promo fixed 800px; form column takes remaining width (overrides style.css repeat(2, 1fr)) */\n  display: grid;\n  grid-template-columns: 40% minmax(0, 1fr);\n  flex: 1 1 auto;\n  width: 100%;\n  min-height: 0;\n  min-height: 100%;\n  align-items: stretch;\n  align-content: stretch;\n  box-sizing: border-box;\n}\n\nbody.signupbg .sign_rewards {\n  display: flex;\n  flex-direction: column;\n  padding: 90px 0px;\n  justify-content: center;\n  border-right: 1px solid #ffffff11;\n  align-items: center;\n  min-height: 100%;\n  min-height: calc(100vh - 58px);\n  min-height: calc(100dvh - 58px);\n  width: 100%;\n  max-width: 100%;\n  min-width: 0;\n  box-sizing: border-box;\n  background-color: #000000;\n}\n\nbody.signupbg .login_section.bgsignup {\n  flex: 1 1 auto;\n  display: flex;\n  align-items: center;\n  min-height: 100%;\n  min-height: calc(100vh - 58px);\n  min-height: calc(100dvh - 58px);\n  width: 100%;\n  min-width: 0;\n  max-width: none;\n  margin: 0;\n  box-sizing: border-box;\n  background-color: #000000;\n}\n\nbody.light_theme.signupbg .login_section.bgsignup {\n  background-color: #ffffff;\n}\n\n/* Tablet / mobile: left promo hidden in global CSS — single column, full white */\n@media screen and (max-width: 991px) {\n  body.signupbg {\n    background: #ffffff;\n  }\n\n  body.signupbg .sign_in_form_s {\n    grid-template-columns: 1fr;\n    min-height: calc(100vh - 58px);\n    min-height: calc(100dvh - 58px);\n  }\n\n  body.signupbg .login_section.bgsignup {\n    min-height: calc(100vh - 58px);\n    min-height: calc(100dvh - 58px);\n    max-width: 100%;\n  }\n}\n\n/* Short viewports (mobile browser chrome) */\n@media screen and (max-width: 575px) {\n\n  body.signupbg .login_fullhieght,\n  body.signupbg .sign_in_form_s,\n  body.signupbg .login_section.bgsignup,\n  body.signupbg .sign_rewards {\n    min-height: calc(100svh - 58px);\n  }\n}\n\n/* -------------------------------------------------------------------------- */\n/* Steps 2–4: hide left promo; single column; centered form (Create Account)   */\n/* -------------------------------------------------------------------------- */\n\nbody.signupbg.signup-wizard-full-steps {\n  background: #ffffff;\n}\n\nbody.signupbg.signup-wizard-full-steps .sign_in_form_s {\n  grid-template-columns: 1fr !important;\n  max-width: 100%;\n}\n\nbody.signupbg.signup-wizard-full-steps .sign_rewards {\n  display: none !important;\n}\n\nbody.signupbg.signup-wizard-full-steps .login_section.bgsignup {\n  max-width: 100%;\n  width: 100%;\n  flex: 1 1 auto;\n  padding: 24px 0px;\n  justify-content: center;\n  align-items: center;\n  background-color: #000000;\n}\n\nbody.light_theme.signupbg.signup-wizard-full-steps .login_section.bgsignup {\n  background-color: #ffffff;\n}\n\nbody.signupbg.signup-wizard-full-steps .login_form_right {\n  width: 100%;\n  max-width: 580px;\n  margin-left: auto;\n  margin-right: auto;\n  padding-left: 24px;\n  padding-right: 24px;\n  box-sizing: border-box;\n}\n\n/* Step 4 (welcome / verify bonus): wider content; steps 2–3 stay at 520px above */\nbody.signupbg.signup-wizard-full-steps .login_form_right.signup-wizard-welcome-wide {\n  max-width: 920px;\n}\n\nbody.signupbg.signup-wizard-full-steps .form_block_login {\n  margin-left: auto;\n  margin-right: auto;\n  width: 100%;\n}\n\n@media screen and (max-width: 1200px) {\n\n  body.signupbg .sign_rewards {\n    display: none;\n  }\n\n  body.signupbg .sign_in_form_s {\n    display: flex;\n    padding: 0px;\n    width: 100%;\n  }\n\n  body.signupbg .login_fullhieght {\n    padding: 90px 0px;\n  }\n\n}\n\n\n@media screen and (max-width: 991px) {\n\n  body.signupbg .login_fullhieght {\n    padding: 50px 0px;\n  }\n\n\n  body.signupbg.signup-wizard-full-steps {\n    background: #ffffff;\n  }\n\n  body.signupbg.signup-wizard-full-steps .login_form_right {\n    padding-left: 16px;\n    padding-right: 16px;\n  }\n}\n\n@media screen and (max-width: 767px) {\n  h3.mb-2.verify_hd {\n    font-size: 1.35rem;\n    margin-top: -24px;\n    line-height: 1.25;\n  }\n\n  body.signupbg .sign_in_form_s {\n    padding: 40px 20px;\n  }\n\n  body.signupbg .sign_rewards {\n    display: none;\n  }\n\n  .form_block_login .login_btn button.next_btn {\n    padding: 15px 14px;\n    font-size: 16px;\n  }\n\n  body.signupbg .login_section.bgsignup .form_block_login h2 {\n    font-size: 28px;\n    line-height: 1.2;\n  }\n\n  body.signupbg.signup-wizard-full-steps .login_form_right,\n  body.signupbg.signup-wizard-full-steps .login_form_right.signup-wizard-welcome-wide {\n    padding-left: 14px;\n    padding-right: 14px;\n  }\n\n  .form_block_login .signup-wizard-otp-row {\n    gap: 6px;\n  }\n\n  .form_block_login .signup-wizard-welcome-img {\n    margin: 0px 0px;\n  }\n\n  .form_block_login .signup-wizard-otp-cell {\n    height: 50px;\n    font-size: 1.05rem;\n  }\n\n  .form_block_login .signup-wizard-priv-table th,\n  .form_block_login .signup-wizard-priv-table td {\n    font-size: 0.8125rem;\n    padding: 8px 5px;\n  }\n\n  .form_block_login .signup-wizard-priv-table th {\n    font-size: 0.9rem;\n  }\n\n\n  body.signupbg .login_section.bgsignup .nav.nav-tabs.login-pills .nav-link {\n    font-size: 14px;\n    padding: 8px 12px;\n    white-space: nowrap;\n    flex-shrink: 0;\n  }\n\n  #VerificationOptionsModal .modal-header p {\n    font-size: 14px;\n  }\n\n  form.profile_form strong {\n    font-size: 16px;\n  }\n\n  form.profile_form .small {\n    font-size: 14px;\n  }\n\n  .modal-content {\n    padding-bottom: 24px;\n  }\n\n\n  h5#exampleModalLabel {\n    width: 90%;\n    font-size: 20px;\n  }\n\n  body.signupbg .login_fullhieght {\n    padding: 20px 0px 0px !important;\n  }\n\n  body.light_theme.signupbg .sign_in_form_s {\n    background-color: #fff !important;\n  }\n\n  body.signupbg .sign_in_form_s {\n    background-color: #000 !important;\n  }\n\n}\n\n/* Narrow phones */\n@media screen and (max-width: 575px) {\n\n  .form_block_login .signup-wizard-social-row {\n    gap: 10px;\n  }\n\n  body.signupbg .login_section.bgsignup .nav.nav-tabs.login-pills {\n    display: flex;\n    flex-wrap: nowrap;\n    gap: 4px;\n    overflow-x: auto;\n    -webkit-overflow-scrolling: touch;\n    scrollbar-width: thin;\n    padding-bottom: 2px;\n  }\n\n  body.signupbg .sign_in_form_s {\n    padding: 10px 0px;\n    background-color: #000;\n  }\n\n  .signupbg .login_section.bgsignup {\n    padding: 0px 20px;\n  }\n\n  body.signupbg .login_section.bgsignup .form_block_login h2 {\n    font-size: 24px;\n  }\n\n  .form_block_login.login-wizard-root .login-wizard-next-btn {\n    padding: 12px 16px;\n    font-size: 15px;\n  }\n\n  .form_block_login .login_btn button.next_btn {\n    padding: 10px 14px;\n    font-size: 13px;\n  }\n\n  body.signupbg .form_block_login .row {\n    gap: 12px;\n  }\n\n  body.signupbg.signup-wizard-full-steps .login_form_right,\n  body.signupbg.signup-wizard-full-steps .login_form_right.signup-wizard-welcome-wide {\n    padding-left: 12px;\n    padding-right: 12px;\n  }\n\n  .form_block_login .signup-wizard-subtitle {\n    font-size: 0.8125rem;\n    margin-bottom: 12px;\n  }\n\n  .form_block_login .signup-wizard-otp-row {\n    gap: 4px;\n  }\n\n  .form_block_login .signup-wizard-otp-cell {\n    height: 46px;\n    font-size: 0.95rem;\n    border-radius: 8px;\n  }\n\n  .form_block_login .signup-wizard-otp-link {\n    font-size: 0.8125rem;\n  }\n\n  .form_block_login .signup-wizard-rule-row {\n    font-size: 11px;\n    gap: 4px;\n  }\n\n  .form_block_login .signup-wizard-social-btn {\n    width: 44px;\n    height: 44px;\n  }\n\n  h3.mb-2.verify_hd {\n    font-size: 1.1rem;\n    margin-top: -50px;\n    margin-bottom: 8px;\n  }\n\n  .form_block_login .signup-wizard-welcome-img img {\n    max-width: 150px;\n  }\n\n  .form_block_login .signup-wizard-priv-table {\n    width: 100%;\n    max-width: 100%;\n    margin-left: 0;\n    margin-right: 0;\n  }\n\n  .form_block_login .signup-wizard-priv-table th,\n  .form_block_login .signup-wizard-priv-table td {\n    font-size: 0.7rem;\n    padding: 6px 3px;\n  }\n\n  .form_block_login .signup-wizard-priv-table th {\n    font-size: 0.75rem;\n  }\n\n  body.signupbg.signup-wizard-full-steps .login_form_right.signup-wizard-welcome-wide .col-sm-12.login_btn {\n    width: 100%;\n  }\n\n  .form_block_login .login_btn input[type=\"submit\"],\n  .form_block_login .login_btn input[type=\"button\"] {\n    padding: 11px 12px;\n    font-size: 0.875rem;\n  }\n}\n\n/* -------------------------------------------------------------------------- */\n/* signup-step-centered: body-class-independent vertical centering for steps  */\n/* 2, 3, 4 and RegistrationResult. Works regardless of body class timing.     */\n/* -------------------------------------------------------------------------- */\n\n.sign_in_form_s.signup-step-centered {\n  display: flex !important;\n  flex-direction: column;\n  flex: 1 1 auto;\n  min-height: calc(100vh - 58px);\n  min-height: calc(100dvh - 58px);\n  align-items: stretch;\n  align-content: stretch;\n  box-sizing: border-box;\n  background: #ffffff;\n}\n\n.sign_in_form_s.signup-step-centered>.login_section.bgsignup {\n  flex: 1 1 auto;\n  display: flex !important;\n  align-items: center;\n  justify-content: center;\n  min-height: calc(100vh - 58px);\n  min-height: calc(100dvh - 58px);\n  width: 100%;\n  box-sizing: border-box;\n  background-color: #ffffff;\n  padding: 24px 16px;\n}\n\n.sign_in_form_s.signup-step-centered .login_form_right {\n  width: 100%;\n  max-width: 580px;\n  margin-left: auto;\n  margin-right: auto;\n  box-sizing: border-box;\n}\n\n.sign_in_form_s.signup-step-centered .login_form_right.signup-wizard-welcome-wide {\n  max-width: 920px;\n}\n\n@media screen and (max-width: 575px) {\n  .sign_in_form_s.signup-step-centered>.login_section.bgsignup {\n    padding: 16px 12px;\n    min-height: calc(100svh - 58px);\n    align-items: flex-start;\n  }\n\n  .sign_in_form_s.signup-step-centered .login_form_right,\n  .sign_in_form_s.signup-step-centered .login_form_right.signup-wizard-welcome-wide {\n    max-width: 100%;\n    padding-left: 0;\n    padding-right: 0;\n  }\n}\n\n\n@media screen and (max-width: 440px) {\n\n  body.signupbg .login_fullhieght {\n    padding: 40px 0px 0px !important;\n  }\n\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
